var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingsoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.83vw",
    height: "11.99vw",
    viewBox: "0 0 372 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13970_23982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 336,
    height: 136,
    rx: 16,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13970_23982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 30C18 21.1634 25.1634 14 34 14H151L191 150H34C25.1634 150 18 142.837 18 134V30Z",
    fill: "url(#paint0_linear_13970_23982)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7357 73.4655H57.8652V127.312H86.7357V73.4655Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2534 83.683H57.3418V126.337H87.2534V83.683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2534 60.329H57.3418V82.7134H87.2534V60.329Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2534 60.329H57.3418V62.2734H87.2534V60.329Z",
    fill: "#D4D4D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5935 86.6022H59.1305V100.389H60.5935V86.6022Z",
    fill: "#969696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5935 67.0624H59.1305V75.7403H60.5935V67.0624Z",
    fill: "#969696"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4723 62.8274H75.8689V66.1728H83.4723V62.8274Z",
    fill: "#D4D4D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.061 63.1205H78.0152V65.8799H83.061V63.1205Z",
    fill: "#34495E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7548 64.985C79.7548 65.2514 79.5359 65.4698 79.2689 65.4698C79.002 65.4698 78.7831 65.2514 78.7831 64.985C78.7831 64.7187 79.002 64.5002 79.2689 64.5002C79.5359 64.5002 79.7548 64.7187 79.7548 64.985Z",
    fill: "#577B9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5995 63.5307H82.6926C82.7567 63.5307 82.8101 63.584 82.8101 63.6479V65.3632C82.8101 65.4272 82.7567 65.4804 82.6926 65.4804H80.5995C80.5354 65.4804 80.4821 65.4272 80.4821 65.3632V63.6533C80.4821 63.5893 80.5354 63.5361 80.5995 63.5361V63.5307Z",
    fill: "#577B9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.693 63.5307H79.8357C79.8837 63.5307 79.9211 63.568 79.9211 63.616V64.0528C79.9211 64.1007 79.8837 64.138 79.8357 64.138H78.693C78.645 64.138 78.6076 64.1007 78.6076 64.0528V63.616C78.6076 63.568 78.645 63.5307 78.693 63.5307Z",
    fill: "#577B9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M57.3418 60.329V62.2734V82.7134H57.8651V83.6829H57.3418V126.342H57.8651V127.317H72.2976V60.329H57.3418Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.308 95.8021H83.0235V131.014H110.308V95.8021Z",
    fill: "#6B6B6B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.6658 95.8021H83.0235V131.014H96.6658V95.8021Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.467 92.3182H81.8594V129.8H111.467V92.3182Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.467 92.3182H81.8594V99.089H111.467V92.3182Z",
    fill: "#D4D4D4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.451 95.7382C107.451 96.4094 106.907 96.9475 106.239 96.9475C105.572 96.9475 105.027 96.4041 105.027 95.7382C105.027 95.0723 105.572 94.529 106.239 94.529C106.907 94.529 107.451 95.0723 107.451 95.7382Z",
    fill: "#999999"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.234 95.7382C109.234 96.0738 108.962 96.3455 108.626 96.3455C108.289 96.3455 108.017 96.0738 108.017 95.7382C108.017 95.4026 108.289 95.1309 108.626 95.1309C108.962 95.1309 109.234 95.4026 109.234 95.7382Z",
    fill: "#999999"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.126 96.4309C103.747 96.9795 102.989 97.1181 102.439 96.7398C101.889 96.3616 101.75 95.6052 102.129 95.0565C102.508 94.5078 103.266 94.3693 103.816 94.7475C104.366 95.1257 104.505 95.8822 104.126 96.4309Z",
    fill: "#666666"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.677 94.9501L103.282 95.8024L103.047 95.6373L103.677 94.9501Z",
    fill: "#3B3B3B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2744 94.529H84.9883V96.9528H90.2744V94.529Z",
    fill: "#A3A3A3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.163 113.351C105.732 108.663 102.384 104.403 97.685 103.836C92.9863 103.269 88.7163 106.609 88.1477 111.297C87.5791 115.985 90.9272 120.245 95.6259 120.812C100.325 121.379 104.595 118.039 105.163 113.351Z",
    fill: "#A3A3A3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.768 112.332C103.768 116.248 100.591 119.417 96.6663 119.417C92.7418 119.417 89.5648 116.248 89.5648 112.332C89.5648 108.417 92.7471 105.247 96.6663 105.247C100.585 105.247 103.768 108.417 103.768 112.332Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.71 112.385C102.71 115.715 100.003 118.415 96.6657 118.415C93.3285 118.415 90.6214 115.715 90.6214 112.385C90.6214 109.056 93.3285 106.355 96.6657 106.355C100.003 106.355 102.71 109.056 102.71 112.385Z",
    fill: "#34495E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3626 94.593H90.9255V97.0168H95.3626V94.593Z",
    fill: "#34495E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4536 96.2283C92.4536 96.4627 92.2614 96.6545 92.0265 96.6545C91.7915 96.6545 91.5993 96.4627 91.5993 96.2283C91.5993 95.9939 91.7915 95.8022 92.0265 95.8022C92.2614 95.8022 92.4536 95.9939 92.4536 96.2283Z",
    fill: "#577B9E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.026 94.95H93.1892C93.1332 94.95 93.0878 94.9953 93.0878 95.0512V96.5588C93.0878 96.6147 93.1332 96.66 93.1892 96.66H95.026C95.082 96.66 95.1274 96.6147 95.1274 96.5588V95.0512C95.1274 94.9953 95.082 94.95 95.026 94.95Z",
    fill: "#577B9E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5181 94.95H92.5219C92.5646 94.95 92.5967 94.9819 92.5967 95.0246V95.4081C92.5967 95.4507 92.5646 95.4827 92.5219 95.4827H91.5181C91.4754 95.4827 91.4434 95.4507 91.4434 95.4081V95.0246C91.4434 94.9819 91.4754 94.95 91.5181 94.95Z",
    fill: "#577B9E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.6604 92.3182H81.8594V129.8H96.6604V92.3182Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.859 132.974H117.347C116.99 132.974 116.7 132.684 116.7 132.328V131.254H132.506V132.328C132.506 132.684 132.215 132.974 131.859 132.974Z",
    fill: "#525252"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M131.962 118.158H117.038C113.151 118.158 110 121.301 110 125.18V125.324C110 129.203 113.151 132.346 117.038 132.346H131.962C135.849 132.346 139 129.203 139 125.324V125.18C139 121.301 135.849 118.158 131.962 118.158Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.082 130.742H116.433C113.422 130.742 110.985 128.311 110.985 125.306V125.198C110.985 122.193 113.422 119.762 116.433 119.762H119.082V130.742Z",
    fill: "#696969"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M119.083 130.084H116.954C114.542 130.084 112.583 128.13 112.583 125.723V125.632C112.583 123.225 114.542 121.27 116.954 121.27H119.083V130.078V130.084Z",
    fill: "#4D4D4D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M130.014 130.742H132.663C135.674 130.742 138.111 128.311 138.111 125.306V125.198C138.111 122.193 135.674 119.762 132.663 119.762H130.014V130.742Z",
    fill: "#696969"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.051 130.084H132.179C134.592 130.084 136.551 128.13 136.551 125.723V125.632C136.551 123.225 134.592 121.27 132.179 121.27H130.051V130.078V130.084Z",
    fill: "#4D4D4D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M129.411 118.574C129.411 118.96 127.228 119.28 124.531 119.28C121.834 119.28 119.651 118.966 119.651 118.574C119.651 118.182 121.834 117.868 124.531 117.868C127.228 117.868 129.411 118.182 129.411 118.574Z",
    fill: "#919191"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.41 119.762H119.657V124.486H129.41V119.762Z",
    fill: "#BABABA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M129.41 125.059H119.657V126.302H129.41V125.059Z",
    fill: "#6E6E6E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M129.41 127.062H119.657V130.742H129.41V127.062Z",
    fill: "#B0B0B0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M128.061 128.172H121.005V130.483H128.061V128.172Z",
    fill: "#8C8C8C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.193 125.663C118.193 126.314 117.667 126.839 117.014 126.839C116.361 126.839 115.835 126.314 115.835 125.663C115.835 125.011 116.361 124.486 117.014 124.486C117.667 124.486 118.193 125.011 118.193 125.663Z",
    fill: "#363636"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M133.299 125.663C133.299 126.314 132.773 126.839 132.12 126.839C131.467 126.839 130.941 126.314 130.941 125.663C130.941 125.011 131.467 124.486 132.12 124.486C132.773 124.486 133.299 125.011 133.299 125.663Z",
    fill: "#363636"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M124.53 117.874C122.922 117.874 121.501 117.989 120.612 118.158H117.038C113.15 118.158 110 121.301 110 125.18V125.325C110 129.089 112.969 132.148 116.694 132.329C116.694 132.685 116.984 132.974 117.341 132.974H124.53V117.874Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40.122 91.4605H38.2212V98.0075H40.122V91.4605Z",
    fill: "#757575"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8052 98.0073H37.4306V109.445H40.8052V98.0073Z",
    fill: "#B0B0B0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.272 109.445H37.9706V125.048H40.272V109.445Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0464 125.048H34.2432V125.943H44.0464V125.048Z",
    fill: "#B0B0B0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1669 125.943H34.2432V126.944H35.1669V125.943Z",
    fill: "#2E2E2E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0469 125.943H43.1232V126.944H44.0469V125.943Z",
    fill: "#2E2E2E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3831 99.4616H37.8469V104.08H40.3831V99.4616Z",
    fill: "#34495E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6699 101.049C38.4242 101.049 38.2213 100.852 38.2213 100.601C38.2213 100.351 38.4242 100.154 38.6699 100.154C38.9155 100.154 39.1184 100.356 39.1184 100.601C39.1184 100.846 38.9208 101.049 38.6699 101.049Z",
    fill: "#577B9E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9033 101.715H38.3281C38.2692 101.715 38.2213 101.763 38.2213 101.822V103.734C38.2213 103.793 38.2692 103.841 38.3281 103.841H39.9033C39.9623 103.841 40.0101 103.793 40.0101 103.734V101.822C40.0101 101.763 39.9623 101.715 39.9033 101.715Z",
    fill: "#577B9E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5296 99.9997H39.9301C39.9728 99.9997 40.0102 100.037 40.0102 100.08V101.129C40.0102 101.172 39.9728 101.209 39.9301 101.209H39.5296C39.4869 101.209 39.4495 101.172 39.4495 101.129V100.08C39.4495 100.037 39.4869 99.9997 39.5296 99.9997Z",
    fill: "#577B9E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2679 80.6892H39.1238V86.4211H39.2679V80.6892Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1489 88.2269H40.544V88.3708H47.1489V88.2269Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2563 89.2211L33.4215 94.048L33.5235 94.1497L38.3583 89.3227L38.2563 89.2211Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9438 90.9012C40.5021 92.3395 38.1688 92.3395 36.7271 90.9012C35.2855 89.4629 35.2855 87.135 36.7271 85.6967C38.1688 84.2583 40.5021 84.2583 41.9438 85.6967C43.3854 87.135 43.3854 89.4629 41.9438 90.9012Z",
    fill: "#B0B0B0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6304 83.4166C42.5785 83.2036 42.3436 86.3465 40.117 86.6289L41.1636 88.3761C42.2261 87.9074 44.9386 88.5306 45.6647 86.8153C46.0972 85.3877 44.6769 83.6297 43.6304 83.4166Z",
    fill: "#6188CC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3719 94.5397C42.1034 93.7566 39.5351 91.9187 40.4482 89.8731L38.4085 89.8518C38.259 91.0025 36.3101 92.9895 37.3993 94.5024C38.3978 95.6104 40.6404 95.3227 41.3719 94.5397Z",
    fill: "#6188CC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7827 83.5285C35.8186 83.2568 36.2244 86.3838 38.4616 86.5543L37.5112 88.3549C36.4219 87.9394 33.7469 88.7065 32.9299 87.0337C32.4227 85.6274 33.7469 83.8002 34.7827 83.5285Z",
    fill: "#6188CC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3526 89.9955C39.4128 90.5548 38.1954 90.2512 37.6294 89.3083C37.0688 88.3707 37.3732 87.1562 38.3182 86.5968C39.258 86.0375 40.4754 86.3411 41.036 87.284C41.5967 88.2269 41.2923 89.4361 40.3472 89.9955H40.3526Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7375 88.9728C39.3637 89.1965 38.8778 89.074 38.6589 88.7011C38.4346 88.3282 38.5574 87.8435 38.9312 87.6251C39.305 87.4013 39.7908 87.5238 40.0098 87.8967C40.234 88.2696 40.1112 88.7544 39.7375 88.9728Z",
    fill: "#B0B0B0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4641 94.156C30.3245 91.0237 30.3245 85.931 33.4641 82.804C36.6037 79.677 41.7082 79.677 44.8425 82.804C47.9821 85.9363 47.9821 91.029 44.8425 94.156C41.7029 97.2883 36.5983 97.2883 33.4641 94.156ZM44.6182 83.0277C41.6067 80.0233 36.7051 80.0233 33.6937 83.0277C30.6822 86.0322 30.6822 90.9225 33.6937 93.9269C36.7051 96.9314 41.6067 96.9314 44.6182 93.9269C47.6297 90.9225 47.6297 86.0322 44.6182 83.0277Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M39.3316 80.4547C37.2706 80.4547 35.028 81.2378 33.4582 82.8039C30.3186 85.9363 30.3186 91.029 33.4582 94.156C34.7877 95.4824 36.475 96.2442 38.2157 96.4413V98.0074H37.4254V109.445H37.9594V125.048H34.2378V126.944H35.1615V125.943H39.1447L39.2622 80.7743H39.3263V80.4547H39.3316ZM33.6878 83.0277C35.1882 81.5308 37.1531 80.785 39.1234 80.7743V84.6205C38.2691 84.6684 37.4254 85.0094 36.7687 85.6486C35.893 84.6897 35.4819 83.342 34.7824 83.5231C33.7465 83.7948 32.4224 85.622 32.9296 87.0283C33.4155 88.0298 34.5688 88.1577 35.6474 88.1896C35.6207 89.1325 35.9571 90.0861 36.6512 90.8212L33.6184 93.847C30.6817 90.8372 30.7031 86.0055 33.6878 83.0277ZM33.7145 93.9535L36.7473 90.9277C37.025 91.1994 37.3293 91.4125 37.6604 91.583C37.1745 92.5419 36.7473 93.6073 37.3987 94.5075C37.6177 94.7526 37.9006 94.9284 38.2157 95.0456V96.1216C36.5711 95.9245 34.98 95.2054 33.7145 93.9589V93.9535Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M62.617 127.115H41.9854V127.834H62.617V127.115Z",
    fill: "#545454"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8455 108.278H41.7173V127.429H62.8455V108.278Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7166 109.061H42.7059C42.5319 109.061 42.3909 109.202 42.3909 109.375V113.365C42.3909 113.539 42.5319 113.68 42.7059 113.68H42.7166C42.8906 113.68 43.0316 113.539 43.0316 113.365V109.375C43.0316 109.202 42.8906 109.061 42.7166 109.061Z",
    fill: "#787878"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9925 109.061H43.9819C43.8079 109.061 43.6668 109.202 43.6668 109.375V113.365C43.6668 113.539 43.8079 113.68 43.9819 113.68H43.9925C44.1665 113.68 44.3076 113.539 44.3076 113.365V109.375C44.3076 109.202 44.1665 109.061 43.9925 109.061Z",
    fill: "#787878"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5444 109.061H46.5338C46.3598 109.061 46.2187 109.202 46.2187 109.375V113.365C46.2187 113.539 46.3598 113.68 46.5338 113.68H46.5444C46.7184 113.68 46.8595 113.539 46.8595 113.365V109.375C46.8595 109.202 46.7184 109.061 46.5444 109.061Z",
    fill: "#787878"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2695 109.061H45.2588C45.0848 109.061 44.9438 109.202 44.9438 109.375V113.365C44.9438 113.539 45.0848 113.68 45.2588 113.68H45.2695C45.4434 113.68 45.5845 113.539 45.5845 113.365V109.375C45.5845 109.202 45.4434 109.061 45.2695 109.061Z",
    fill: "#787878"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8214 109.061H47.8107C47.6367 109.061 47.4957 109.202 47.4957 109.375V113.365C47.4957 113.539 47.6367 113.68 47.8107 113.68H47.8214C47.9954 113.68 48.1364 113.539 48.1364 113.365V109.375C48.1364 109.202 47.9954 109.061 47.8214 109.061Z",
    fill: "#787878"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1022 109.061H49.0915C48.9175 109.061 48.7765 109.202 48.7765 109.375V113.365C48.7765 113.539 48.9175 113.68 49.0915 113.68H49.1022C49.2762 113.68 49.4172 113.539 49.4172 113.365V109.375C49.4172 109.202 49.2762 109.061 49.1022 109.061Z",
    fill: "#787878"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3781 109.061H50.3675C50.1935 109.061 50.0524 109.202 50.0524 109.375V113.365C50.0524 113.539 50.1935 113.68 50.3675 113.68H50.3781C50.5521 113.68 50.6932 113.539 50.6932 113.365V109.375C50.6932 109.202 50.5521 109.061 50.3781 109.061Z",
    fill: "#787878"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6551 109.061H51.6444C51.4704 109.061 51.3293 109.202 51.3293 109.375V113.365C51.3293 113.539 51.4704 113.68 51.6444 113.68H51.6551C51.829 113.68 51.9701 113.539 51.9701 113.365V109.375C51.9701 109.202 51.829 109.061 51.6551 109.061Z",
    fill: "#787878"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M52.931 109.061H52.9203C52.7464 109.061 52.6053 109.202 52.6053 109.375V113.365C52.6053 113.539 52.7464 113.68 52.9203 113.68H52.931C53.105 113.68 53.246 113.539 53.246 113.365V109.375C53.246 109.202 53.105 109.061 52.931 109.061Z",
    fill: "#787878"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M54.207 109.061H54.1963C54.0223 109.061 53.8813 109.202 53.8813 109.375V113.365C53.8813 113.539 54.0223 113.68 54.1963 113.68H54.207C54.3809 113.68 54.522 113.539 54.522 113.365V109.375C54.522 109.202 54.3809 109.061 54.207 109.061Z",
    fill: "#787878"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4829 109.061H55.4722C55.2982 109.061 55.1572 109.202 55.1572 109.375V113.365C55.1572 113.539 55.2982 113.68 55.4722 113.68H55.4829C55.6569 113.68 55.7979 113.539 55.7979 113.365V109.375C55.7979 109.202 55.6569 109.061 55.4829 109.061Z",
    fill: "#787878"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7589 109.061H56.7482C56.5742 109.061 56.4332 109.202 56.4332 109.375V113.365C56.4332 113.539 56.5742 113.68 56.7482 113.68H56.7589C56.9329 113.68 57.0739 113.539 57.0739 113.365V109.375C57.0739 109.202 56.9329 109.061 56.7589 109.061Z",
    fill: "#787878"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0358 109.061H58.0251C57.8511 109.061 57.7101 109.202 57.7101 109.375V113.365C57.7101 113.539 57.8511 113.68 58.0251 113.68H58.0358C58.2098 113.68 58.3508 113.539 58.3508 113.365V109.375C58.3508 109.202 58.2098 109.061 58.0358 109.061Z",
    fill: "#787878"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3117 109.061H59.301C59.1271 109.061 58.986 109.202 58.986 109.375V113.365C58.986 113.539 59.1271 113.68 59.301 113.68H59.3117C59.4857 113.68 59.6268 113.539 59.6268 113.365V109.375C59.6268 109.202 59.4857 109.061 59.3117 109.061Z",
    fill: "#787878"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5877 109.061H60.577C60.403 109.061 60.262 109.202 60.262 109.375V113.365C60.262 113.539 60.403 113.68 60.577 113.68H60.5877C60.7617 113.68 60.9027 113.539 60.9027 113.365V109.375C60.9027 109.202 60.7617 109.061 60.5877 109.061Z",
    fill: "#787878"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8636 109.061H61.853C61.679 109.061 61.5379 109.202 61.5379 109.375V113.365C61.5379 113.539 61.679 113.68 61.853 113.68H61.8636C62.0376 113.68 62.1787 113.539 62.1787 113.365V109.375C62.1787 109.202 62.0376 109.061 61.8636 109.061Z",
    fill: "#787878"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8589 115.144H42.7116V118.287H61.8589V115.144Z",
    fill: "#D4D4D4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8558 129.214C42.8558 129.693 42.4661 130.077 41.9855 130.077C41.505 130.077 41.1152 129.688 41.1152 129.214C41.1152 128.74 41.505 128.345 41.9855 128.345C42.4661 128.345 42.8558 128.734 42.8558 129.214Z",
    fill: "#404040"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3907 128.26V127.828H42.1344V128.191C42.0863 128.185 42.0383 128.175 41.9902 128.175C41.4189 128.175 40.9543 128.638 40.9543 129.208H43.0314C43.0314 128.777 42.7698 128.409 42.396 128.255L42.3907 128.26Z",
    fill: "#2E2E2E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8952 129.213C62.8952 129.693 62.5054 130.076 62.0249 130.076C61.5443 130.076 61.1599 129.688 61.1599 129.213C61.1599 128.739 61.5497 128.345 62.0249 128.345C62.5001 128.345 62.8952 128.734 62.8952 129.213Z",
    fill: "#404040"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4303 128.26V127.828H62.174V128.191C62.126 128.185 62.0779 128.175 62.0299 128.175C61.4585 128.175 60.994 128.638 60.994 129.208H63.0711C63.0711 128.777 62.8094 128.409 62.4357 128.255L62.4303 128.26Z",
    fill: "#2E2E2E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1 115.81H57.7949V117.616H61.1V115.81Z",
    fill: "#34495E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M58.933 117.03C58.933 117.206 58.7888 117.35 58.6126 117.35C58.4364 117.35 58.2922 117.206 58.2922 117.03C58.2922 116.854 58.4364 116.711 58.6126 116.711C58.7888 116.711 58.933 116.854 58.933 117.03Z",
    fill: "#577B9E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8553 116.077H59.4831C59.4418 116.077 59.4083 116.11 59.4083 116.151V117.275C59.4083 117.317 59.4418 117.35 59.4831 117.35H60.8553C60.8966 117.35 60.9301 117.317 60.9301 117.275V116.151C60.9301 116.11 60.8966 116.077 60.8553 116.077Z",
    fill: "#577B9E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9913 116.077H58.2438C58.2113 116.077 58.185 116.103 58.185 116.135V116.418C58.185 116.45 58.2113 116.476 58.2438 116.476H58.9913C59.0237 116.476 59.05 116.45 59.05 116.418V116.135C59.05 116.103 59.0237 116.077 58.9913 116.077Z",
    fill: "#577B9E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M52.2849 108.278H41.7181V127.429H41.9851V127.834H42.1292V128.196C42.0812 128.191 42.0331 128.18 41.9851 128.18C41.4138 128.18 40.9492 128.643 40.9492 129.213H41.1201C41.1201 129.693 41.5099 130.076 41.9904 130.076C42.471 130.076 42.8607 129.688 42.8607 129.213H43.0316C43.0316 128.782 42.77 128.414 42.3962 128.26V127.828H52.2902V108.273L52.2849 108.278Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7615 48.2845H59.589V60.329H79.7615V48.2845Z",
    fill: "#6B6B6B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2207 47.1925H59.1299V59.7804H80.2207V47.1925Z",
    fill: "#E6E6E6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2866 48.9398H60.8221V57.575H75.2866V48.9398Z",
    fill: "#262E36"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4837 51.1931H76.0184V54.6824H79.4837V51.1931Z",
    fill: "#969696"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4837 55.4708H76.0184V56.3391H79.4837V55.4708Z",
    fill: "#666666"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4837 56.7121H76.0184V57.5804H79.4837V56.7121Z",
    fill: "#666666"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 48.8919H75.9859V50.783H79.4512V48.8919Z",
    fill: "#34495E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1821 50.1705C77.1821 50.3569 77.0326 50.5061 76.8457 50.5061C76.6589 50.5061 76.5094 50.3569 76.5094 50.1705C76.5094 49.984 76.6589 49.8349 76.8457 49.8349C77.0326 49.8349 77.1821 49.984 77.1821 50.1705Z",
    fill: "#577B9E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1945 49.169H77.7582C77.714 49.169 77.6781 49.2048 77.6781 49.2489V50.4262C77.6781 50.4703 77.714 50.5061 77.7582 50.5061H79.1945C79.2387 50.5061 79.2746 50.4703 79.2746 50.4262V49.2489C79.2746 49.2048 79.2387 49.169 79.1945 49.169Z",
    fill: "#577B9E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2404 49.169H76.4502C76.4177 49.169 76.3914 49.1952 76.3914 49.2276V49.5259C76.3914 49.5583 76.4177 49.5845 76.4502 49.5845H77.2404C77.2728 49.5845 77.2991 49.5583 77.2991 49.5259V49.2276C77.2991 49.1952 77.2728 49.169 77.2404 49.169Z",
    fill: "#577B9E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M69.5739 47.1925H59.1299V59.7804H59.5891V60.3291H69.5739V47.1925Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6085 85.0958H131.013C131.093 85.0958 131.159 85.1618 131.159 85.241V85.8548C131.159 85.9339 131.093 85.9999 131.013 85.9999H92.6085C92.5291 85.9999 92.463 85.9339 92.463 85.8548V85.241C92.463 85.1618 92.5291 85.0958 92.6085 85.0958Z",
    fill: "#2E2E2E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M126.019 78.9386V62.3479C126.019 62.2093 125.907 62.0971 125.768 62.0971H97.907C97.7681 62.0971 97.6557 62.2093 97.6557 62.3479V78.9386L92.1391 84.8186C92.1391 84.8186 92.0928 84.8912 92.0928 84.9308V85.3795C92.0928 85.4719 92.1655 85.5445 92.2581 85.5445H131.463C131.556 85.5445 131.629 85.4719 131.629 85.3795V84.9308C131.629 84.8912 131.615 84.845 131.582 84.8186L126.019 78.9386Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M117.599 80.6479H96.9416L97.3716 80.1661H117.421L117.599 80.6479Z",
    fill: "#9E9E9E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M118.856 84.2181H93.7332L96.6305 81.024H117.738L118.856 84.2181Z",
    fill: "#9E9E9E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M123.281 82.2515H118.975L118.247 80.4103H122.11L123.281 82.2515Z",
    fill: "#9E9E9E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M130.147 84.2181H125.345L122.772 80.4103H126.668L130.147 84.2181Z",
    fill: "#9E9E9E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M122.44 83.3338L121.991 82.5287H120.549L120.926 83.3338H119.398L119.748 84.2181H121.349H122.923H124.524L123.968 83.3338H122.44Z",
    fill: "#9E9E9E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M124.789 62.7967H98.8531V77.3812H124.789V62.7967Z",
    fill: "#FF9900"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M125.107 78.0146H118.896V78.3578H125.107V78.0146Z",
    fill: "#8C8C8C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M126.019 78.9055H97.6554V78.9715H126.019V78.9055Z",
    fill: "#919191"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M111.863 62.0906H97.9131C97.7742 62.0906 97.6617 62.2028 97.6617 62.3414V78.932L92.1451 84.812C92.1451 84.812 92.0988 84.8846 92.0988 84.9242V85.373C92.0988 85.4654 92.1716 85.5379 92.2642 85.5379H92.4692V85.8415C92.4692 85.9207 92.5354 85.9867 92.6148 85.9867H111.863V62.084V62.0906Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M108.443 63.78H105.043C104.967 63.78 104.904 63.842 104.904 63.9186V69.528C104.904 69.6045 104.967 69.6666 105.043 69.6666H108.443C108.52 69.6666 108.582 69.6045 108.582 69.528V63.9186C108.582 63.842 108.52 63.78 108.443 63.78Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M108.291 64.0374H105.235V67.3173H108.291V64.0374Z",
    fill: "#579E8C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M106.128 64.9944V66.1559C106.095 66.1427 106.055 66.1361 106.009 66.1361C105.844 66.1361 105.712 66.2351 105.712 66.3605C105.712 66.4859 105.844 66.5848 106.009 66.5848C106.175 66.5848 106.307 66.4859 106.307 66.3605V65.3574L107.385 65.1924V65.9579C107.352 65.9447 107.312 65.9381 107.266 65.9381C107.101 65.9381 106.968 66.0371 106.968 66.1625C106.968 66.2879 107.101 66.3869 107.266 66.3869C107.431 66.3869 107.564 66.2879 107.564 66.1625V64.7832L106.128 65.001V64.9944Z",
    fill: "#274F45"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M107.266 68.4261C107.266 68.6504 107.034 68.8286 106.743 68.8286C106.452 68.8286 106.221 68.6504 106.221 68.4261C106.221 68.2017 106.452 68.0235 106.743 68.0235C107.034 68.0235 107.266 68.2017 107.266 68.4261Z",
    fill: "#919191"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M108.299 68.4261C108.299 68.6504 107.942 68.8286 107.651 68.8286V68.0235C107.935 68.0235 108.299 68.2017 108.299 68.4261Z",
    fill: "#919191"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M105.235 68.4261C105.235 68.6504 105.592 68.8286 105.883 68.8286V68.0235C105.599 68.0235 105.235 68.2017 105.235 68.4261Z",
    fill: "#919191"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M110.237 71.7849H104.813C104.62 71.7849 104.463 71.9415 104.463 72.1347V75.7709C104.463 75.9641 104.62 76.1207 104.813 76.1207H110.237C110.431 76.1207 110.588 75.9641 110.588 75.7709V72.1347C110.588 71.9415 110.431 71.7849 110.237 71.7849Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M106.765 72.2401H104.959V72.8407H106.765V72.2401Z",
    fill: "#274F45"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M106.031 72.3919H105.125V72.6889H106.031V72.3919Z",
    fill: "#579E8C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M108.92 74.5302C108.92 75.2891 108.298 75.9161 107.531 75.9161C106.764 75.9161 106.142 75.2891 106.142 74.5302C106.142 73.7713 106.764 73.1378 107.531 73.1378C108.298 73.1378 108.92 73.7647 108.92 74.5302Z",
    fill: "#519181"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M108.597 74.5367C108.597 75.1241 108.121 75.5992 107.532 75.5992C106.944 75.5992 106.467 75.1241 106.467 74.5367C106.467 73.9494 106.944 73.4742 107.532 73.4742C108.121 73.4742 108.597 73.9494 108.597 74.5367Z",
    fill: "#274F45"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M109.622 71.5209H108.921V71.7848H109.622V71.5209Z",
    fill: "#1A362F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M108.551 71.5209C108.452 71.5209 108.366 71.6067 108.366 71.7057V71.7848H108.743V71.7057C108.743 71.6067 108.657 71.5209 108.557 71.5209H108.551Z",
    fill: "#1A362F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M114.855 70.7883H118.87C119.069 70.7883 119.228 70.9467 119.228 71.1446V75.8895C119.228 76.0875 119.069 76.2459 118.87 76.2459H114.855C114.657 76.2459 114.498 76.0875 114.498 75.8895V71.1446C114.498 70.9467 114.657 70.7883 114.855 70.7883Z",
    fill: "#274F45"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M118.911 71.0852H114.816V75.6585H118.911V71.0852Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M117.315 75.058H114.814V75.3483H117.315V75.058Z",
    fill: "#579E8C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M118.908 75.058H118.254V75.3483H118.908V75.058Z",
    fill: "#579E8C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M118.115 75.058H117.441V75.3483H118.115V75.058Z",
    fill: "#274F45"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M118.625 71.2765H115.092V72.7878H118.625V71.2765Z",
    fill: "#B0B0B0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M118.115 72.9659H115.092V74.8401H118.115V72.9659Z",
    fill: "#B0B0B0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M116.633 63.6084C116.217 63.6084 115.859 63.8526 115.687 64.2023C115.515 63.8526 115.158 63.6084 114.742 63.6084C114.159 63.6084 113.69 64.077 113.69 64.6577C113.69 65.2384 114.159 65.707 114.742 65.707H116.633C117.215 65.707 117.685 65.2384 117.685 64.6577C117.685 64.077 117.215 63.6084 116.633 63.6084Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M117.91 68.8745H113.478C113.287 68.8745 113.135 68.7359 113.135 68.5577V66.083C113.135 65.9114 113.287 65.7662 113.478 65.7662H117.91C118.102 65.7662 118.254 65.9048 118.254 66.083V68.5577C118.254 68.7293 118.102 68.8745 117.91 68.8745Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M116.687 65.7003H114.742V65.7663H116.687V65.7003Z",
    fill: "#1A332D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M116.686 65.0207C116.887 65.0207 117.05 64.8582 117.05 64.6578C117.05 64.4573 116.887 64.2948 116.686 64.2948C116.485 64.2948 116.322 64.4573 116.322 64.6578C116.322 64.8582 116.485 65.0207 116.686 65.0207Z",
    fill: "#579E8C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M116.898 64.6577C116.898 64.7765 116.805 64.8689 116.686 64.8689C116.567 64.8689 116.475 64.7765 116.475 64.6577C116.475 64.5389 116.567 64.4465 116.686 64.4465C116.805 64.4465 116.898 64.5389 116.898 64.6577Z",
    fill: "#274F45"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M115.112 64.6578C115.112 64.8557 114.946 65.0207 114.748 65.0207C114.55 65.0207 114.384 64.8557 114.384 64.6578C114.384 64.4598 114.55 64.2948 114.748 64.2948C114.946 64.2948 115.112 64.4598 115.112 64.6578Z",
    fill: "#579E8C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M114.954 64.6577C114.954 64.7765 114.861 64.8689 114.742 64.8689C114.623 64.8689 114.531 64.7765 114.531 64.6577C114.531 64.5389 114.623 64.4465 114.742 64.4465C114.861 64.4465 114.954 64.5389 114.954 64.6577Z",
    fill: "#274F45"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 66.7033H118.26V68.4126H118.459V66.7033Z",
    fill: "#274F45"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M119.525 67.0401H118.46V68.0762H119.525V67.0401Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M119.22 67.0401H118.989V68.0762H119.22V67.0401Z",
    fill: "#274F45"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M119.901 68.1685L119.517 68.0762V67.0401L119.901 66.9411V68.1685Z",
    fill: "#274F45"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M115.509 67.1192H115.006V67.5284H115.509V67.1192Z",
    fill: "#579E8C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M114.484 67.1192H113.981V67.5284H114.484V67.1192Z",
    fill: "#579E8C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M116.958 67.8717H113.981V68.2809H116.958V67.8717Z",
    fill: "#579E8C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M135.143 97.2336H122.259C119.355 97.2336 117 99.5828 117 102.481V110.381H140.403V102.481C140.403 99.5828 138.048 97.2336 135.143 97.2336Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M119.569 112.043H118.688C118.426 112.043 118.213 111.83 118.213 111.569V110.386H120.044V111.569C120.044 111.83 119.83 112.043 119.569 112.043Z",
    fill: "#363636"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M138.71 112.043H137.829C137.567 112.043 137.354 111.83 137.354 111.569V110.386H139.185V111.569C139.185 111.83 138.972 112.043 138.71 112.043Z",
    fill: "#363636"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M142.757 102.411V102.854C142.757 102.987 142.453 103.088 142.079 103.088H140.381V102.177H142.079C142.453 102.177 142.757 102.284 142.757 102.411Z",
    fill: "#363636"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M128.704 97.2336H122.264C119.36 97.2336 117.005 99.5828 117.005 102.481V110.381H118.217V111.563C118.217 111.824 118.431 112.038 118.692 112.038H119.573C119.835 112.038 120.048 111.824 120.048 111.563V110.381H128.709V97.2336H128.704Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M137.241 106.045H131.624V109.113H137.241V106.045Z",
    fill: "#34495E"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M133.557 108.122C133.557 108.42 133.317 108.665 133.012 108.665C132.708 108.665 132.468 108.42 132.468 108.122C132.468 107.824 132.708 107.579 133.012 107.579C133.317 107.579 133.557 107.818 133.557 108.122Z",
    fill: "#577B9E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M136.82 106.497H134.492C134.421 106.497 134.363 106.554 134.363 106.625V108.532C134.363 108.603 134.421 108.66 134.492 108.66H136.82C136.89 108.66 136.948 108.603 136.948 108.532V106.625C136.948 106.554 136.89 106.497 136.82 106.497Z",
    fill: "#577B9E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M132.377 106.497H133.653C133.706 106.497 133.749 106.54 133.749 106.593V107.078C133.749 107.131 133.706 107.174 133.653 107.174H132.377C132.323 107.174 132.28 107.131 132.28 107.078V106.593C132.28 106.54 132.323 106.497 132.377 106.497Z",
    fill: "#577B9E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M133.808 94H123.887C123.386 94 122.98 94.4049 122.98 94.9056V97.2335H134.716V94.9056C134.716 94.4049 134.31 94 133.808 94Z",
    fill: "#795547"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M133.707 94.6553H123.989C123.589 94.6553 123.268 94.9802 123.268 95.3744V97.2336H134.433V95.3744C134.433 94.9749 134.107 94.6553 133.712 94.6553H133.707Z",
    fill: "#F0DAA7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 95.6408C125.03 95.8059 124.811 95.9444 124.544 95.9444C124.277 95.9444 124.058 95.8112 124.058 95.6408C124.058 95.4703 124.277 95.3371 124.544 95.3371C124.811 95.3371 125.03 95.4703 125.03 95.6408Z",
    fill: "#BFAE85"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M125.831 96.7648C125.831 96.8767 125.692 96.9619 125.516 96.9619C125.34 96.9619 125.201 96.8714 125.201 96.7648C125.201 96.6583 125.34 96.5677 125.516 96.5677C125.692 96.5677 125.831 96.6583 125.831 96.7648Z",
    fill: "#BFAE85"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M127.454 95.4704C127.454 95.6355 127.24 95.7687 126.973 95.7687C126.706 95.7687 126.493 95.6355 126.493 95.4704C126.493 95.3052 126.706 95.172 126.973 95.172C127.24 95.172 127.454 95.3052 127.454 95.4704Z",
    fill: "#BFAE85"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M128.057 96.3599C128.057 96.5251 127.844 96.6582 127.577 96.6582C127.31 96.6582 127.096 96.5251 127.096 96.3599C127.096 96.1948 127.31 96.0616 127.577 96.0616C127.844 96.0616 128.057 96.1948 128.057 96.3599Z",
    fill: "#BFAE85"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M133.872 96.1681C133.872 96.28 133.728 96.3706 133.546 96.3706C133.365 96.3706 133.22 96.28 133.22 96.1681C133.22 96.0563 133.365 95.9657 133.546 95.9657C133.728 95.9657 133.872 96.0563 133.872 96.1681Z",
    fill: "#BFAE85"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M132.372 96.6636C132.372 96.8447 132.137 96.9885 131.849 96.9885C131.56 96.9885 131.326 96.8394 131.326 96.6636C131.326 96.4878 131.56 96.3333 131.849 96.3333C132.137 96.3333 132.372 96.4825 132.372 96.6636Z",
    fill: "#BFAE85"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M130.636 95.694C130.636 95.8166 130.476 95.9178 130.273 95.9178C130.07 95.9178 129.91 95.8166 129.91 95.694C129.91 95.5715 130.076 95.4703 130.273 95.4703C130.471 95.4703 130.636 95.5715 130.636 95.694Z",
    fill: "#BFAE85"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M130.124 96.4825C130.124 96.653 129.9 96.7968 129.623 96.7968C129.345 96.7968 129.121 96.6583 129.121 96.4825C129.121 96.3067 129.345 96.1682 129.623 96.1682C129.9 96.1682 130.124 96.3067 130.124 96.4825Z",
    fill: "#BFAE85"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M129.238 95.1347C129.238 95.2199 129.125 95.2892 128.987 95.2892C128.848 95.2892 128.736 95.2199 128.736 95.1347C128.736 95.0495 128.848 94.9802 128.987 94.9802C129.125 94.9802 129.238 95.0495 129.238 95.1347Z",
    fill: "#BFAE85"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M132.489 95.2946C132.489 95.3798 132.377 95.4491 132.238 95.4491C132.1 95.4491 131.987 95.3798 131.987 95.2946C131.987 95.2094 132.1 95.1401 132.238 95.1401C132.377 95.1401 132.489 95.2094 132.489 95.2946Z",
    fill: "#BFAE85"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M128.704 94H123.887C123.386 94 122.98 94.4049 122.98 94.9056V97.2335H128.704V94Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M159.572 109.512H159.261V109H149.725V109.512H149.127C146.844 109.512 145 111.357 145 113.629V116.297C145 118.337 146.496 120.061 148.51 120.365L147.979 126.334H159.578V115.554L160.946 109.512H159.578H159.572ZM146.129 116.297V113.629C146.129 111.978 147.472 110.638 149.127 110.638H149.377L148.608 119.232C147.192 118.983 146.129 117.74 146.129 116.291V116.297Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M159.829 126.328H147.577V130.123H159.829V126.328Z",
    fill: "#B0B0B0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M159.829 126.328H147.577V130.123H159.829V126.328Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M149.731 109V109.512H149.132C146.849 109.512 145.006 111.357 145.006 113.629V116.297C145.006 118.337 146.501 120.061 148.516 120.365L147.985 126.334H147.582V130.129H153.711V109H149.737H149.731ZM146.129 116.297V113.629C146.129 111.978 147.472 110.638 149.126 110.638H149.377L148.607 119.232C147.191 118.983 146.129 117.74 146.129 116.291V116.297Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M150.818 124.044C150.818 124.044 150.8 124.044 150.794 124.044C150.562 124.032 150.385 123.831 150.397 123.593L151.142 111.863C151.154 111.631 151.355 111.436 151.593 111.467C151.825 111.479 152.002 111.68 151.99 111.917L151.245 123.654C151.233 123.88 151.044 124.05 150.824 124.05L150.818 124.044Z",
    fill: "#34495E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M158.754 127.041H154.414V129.41H158.754V127.041Z",
    fill: "#34495E"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M155.903 128.649C155.903 128.88 155.713 129.069 155.481 129.069C155.249 129.069 155.06 128.88 155.06 128.649C155.06 128.417 155.249 128.229 155.481 128.229C155.713 128.229 155.903 128.417 155.903 128.649Z",
    fill: "#577B9E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M156.629 127.394H158.424C158.479 127.394 158.522 127.437 158.522 127.492V128.966C158.522 129.02 158.479 129.063 158.424 129.063H156.629C156.574 129.063 156.532 129.02 156.532 128.966V127.492C156.532 127.437 156.574 127.394 156.629 127.394Z",
    fill: "#577B9E"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M155.982 127.394H154.993C154.952 127.394 154.919 127.427 154.919 127.467V127.845C154.919 127.885 154.952 127.918 154.993 127.918H155.982C156.022 127.918 156.055 127.885 156.055 127.845V127.467C156.055 127.427 156.022 127.394 155.982 127.394Z",
    fill: "#577B9E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M132.948 36.1761H88.5664V55.3643H132.948V36.1761Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M132.478 47.2245H89.1054V54.3681H132.478V47.2245Z",
    fill: "#C7C7C7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M132.478 48.2526H89.1054V48.7161H132.478V48.2526Z",
    fill: "#787878"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M132.478 49.4459H89.1054V49.9094H132.478V49.4459Z",
    fill: "#787878"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M132.478 50.6338H89.1054V51.0972H132.478V50.6338Z",
    fill: "#787878"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M132.478 51.8271H89.1054V52.2906H132.478V51.8271Z",
    fill: "#787878"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M132.478 53.015H89.1054V53.4784H132.478V53.015Z",
    fill: "#787878"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8942 43.9164H89.1054V45.7702H97.8942V43.9164Z",
    fill: "#D4D4D4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M130.535 43.1919H122.627V46.3189H130.535V43.1919Z",
    fill: "#C7C7C7"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M129.884 43.7193H125.767V45.9673H129.884V43.7193Z",
    fill: "#34495E"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M127.187 45.2428C127.187 45.4612 127.011 45.6424 126.787 45.6424C126.562 45.6424 126.392 45.4666 126.392 45.2428C126.392 45.0191 126.568 44.8433 126.787 44.8433C127.006 44.8433 127.187 45.0191 127.187 45.2428Z",
    fill: "#577B9E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M127.87 44.0496H129.579C129.632 44.0496 129.675 44.0922 129.675 44.1455V45.5412C129.675 45.5944 129.632 45.6371 129.579 45.6371H127.876C127.822 45.6371 127.78 45.5944 127.78 45.5412V44.1455C127.78 44.0922 127.822 44.0496 127.876 44.0496H127.87Z",
    fill: "#577B9E"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M126.322 44.0496H127.256C127.293 44.0496 127.325 44.0815 127.325 44.1188V44.4704C127.325 44.5077 127.293 44.5397 127.256 44.5397H126.322C126.284 44.5397 126.252 44.5077 126.252 44.4704V44.1135C126.252 44.0762 126.284 44.0443 126.322 44.0443V44.0496Z",
    fill: "#577B9E"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M110.576 36.1761H88.5664V55.3643H110.576V36.1761Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M230.928 101.996L225.806 102.497L225.917 103.603L226.708 111.7L226.82 112.812L227.553 112.746L227.878 113.946C227.999 114.393 228.426 114.681 228.886 114.639L229.318 114.601L231.465 121.913C231.662 122.576 232.259 122.98 232.807 122.822L235.357 122.072C235.904 121.914 236.188 121.248 235.991 120.585C235.702 119.609 234.576 119.882 234.575 119.877C234.584 119.149 233.962 118.41 233.86 118.551C234.466 117.77 233.415 115.771 233.141 116.099C233.559 115.586 233.249 114.556 232.885 114.011C232.901 113.998 232.911 113.986 232.927 113.967L234.289 112.306C235.046 112.375 235.798 112.519 236.538 112.727C239.96 113.701 243.986 114.843 246.279 115.495L244.379 96.0958C242.26 97.1788 238.525 99.0879 235.359 100.7C233.985 101.401 232.472 101.846 230.934 102.002L230.928 101.996Z",
    fill: "#001B45"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M222.074 105.905L222.497 110.22C222.596 111.264 223.53 112.026 224.574 111.921L225.586 111.83L224.794 103.727L223.783 103.818C222.739 103.929 221.974 104.856 222.074 105.905Z",
    fill: "#001B45"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M246.872 94.9051C246.742 94.8024 246.577 94.7429 246.401 94.7644C246.043 94.7966 245.791 95.1167 245.822 95.4629C246.061 97.9298 247.568 113.28 247.809 115.701C247.84 115.852 247.92 115.977 248.031 116.07C248.155 116.173 248.321 116.232 248.502 116.21C248.854 116.179 249.112 115.864 249.081 115.512L247.105 95.336C247.09 95.1601 247.001 95.0079 246.872 94.9051Z",
    fill: "#001B45"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M198 62.8606V96.134L299.429 82.2777V49.0043L198 62.8606Z",
    fill: "url(#paint1_linear_13970_23982)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M198 92.6244V108.509L214.602 89.6617L198 92.6244Z",
    fill: "#6D41DC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M220.278 78.0731V82.238C220.278 84.158 219.73 85.6394 218.629 86.6877C217.528 87.7361 215.988 88.397 214.014 88.6647C212.262 88.904 210.836 88.6021 209.735 87.7645C208.634 86.9213 208.086 85.5881 208.086 83.7649V73.5436C208.086 71.3558 208.571 69.6579 209.547 68.4387C210.522 67.2194 212.046 66.473 214.128 66.1881C214.978 66.0742 215.76 66.0685 216.478 66.1768C217.197 66.285 217.83 66.5072 218.39 66.8377C218.943 67.1681 219.382 67.641 219.696 68.2563C220.015 68.8717 220.169 69.6066 220.169 70.467V74.3527L215.303 75.0193V72.4611C215.303 71.145 214.909 70.5353 214.128 70.6436C213.66 70.7063 213.352 70.8943 213.204 71.2076C213.055 71.521 212.981 71.9312 212.981 72.4497V82.8647C212.981 83.3148 213.084 83.6965 213.295 83.9985C213.506 84.3005 213.78 84.4315 214.128 84.3802C214.447 84.3347 214.721 84.1751 214.955 83.9016C215.189 83.6282 215.303 83.1724 215.303 82.5456V78.7568L220.284 78.0788L220.278 78.0731Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M221.984 81.3776V70.8771C221.984 69.0425 222.486 67.5498 223.49 66.4046C224.494 65.2594 226.001 64.5358 228.014 64.2281C230.085 63.9718 231.62 64.2794 232.624 65.1568C233.628 66.0286 234.13 67.3846 234.13 69.2191V79.7196C234.13 80.6141 234.016 81.446 233.788 82.2094C233.56 82.9729 233.212 83.6737 232.744 84.3118C232.276 84.9499 231.649 85.4741 230.85 85.9014C230.051 86.3287 229.138 86.5908 228.1 86.7048C227.01 86.8814 226.063 86.87 225.265 86.6649C224.466 86.4598 223.833 86.1065 223.371 85.5937C222.903 85.0867 222.555 84.4827 222.327 83.7762C222.098 83.0754 221.984 82.2778 221.984 81.3833V81.3776ZM228.054 82.3861C228.231 82.3633 228.391 82.3063 228.522 82.2208C228.659 82.1354 228.762 82.01 228.842 81.8562C228.922 81.7024 228.984 81.5599 229.03 81.4232C229.076 81.2864 229.11 81.1098 229.127 80.8933C229.144 80.6768 229.155 80.5059 229.161 80.3919C229.161 80.278 229.167 80.1185 229.167 79.9133V70.9512C229.167 70.8942 229.167 70.786 229.173 70.6207C229.173 70.4555 229.173 70.3302 229.173 70.2447C229.173 70.1649 229.161 70.0396 229.161 69.8801C229.161 69.7205 229.144 69.5952 229.121 69.5097C229.098 69.4243 229.07 69.316 229.036 69.1907C229.001 69.0596 228.961 68.9685 228.904 68.9058C228.847 68.8431 228.785 68.7804 228.71 68.7121C228.636 68.6437 228.545 68.6038 228.431 68.5867C228.317 68.5696 228.191 68.5696 228.054 68.5867C227.86 68.6152 227.689 68.6665 227.547 68.752C227.404 68.8374 227.29 68.9571 227.204 69.1109C227.119 69.2647 227.05 69.4015 226.993 69.5268C226.936 69.6522 226.902 69.8231 226.879 70.0567C226.862 70.2846 226.851 70.4498 226.851 70.5467V80.0729C226.851 80.278 226.851 80.4375 226.856 80.5572C226.856 80.6768 226.873 80.8477 226.891 81.0756C226.908 81.3035 226.942 81.4858 226.993 81.6226C227.045 81.7593 227.113 81.9018 227.199 82.0442C227.284 82.1923 227.398 82.2892 227.541 82.3519C227.684 82.4088 227.855 82.4259 228.049 82.3974L228.054 82.3861Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M248.129 83.7593L243.708 84.3633L240.992 68.8376V84.7336L236.263 85.3774V63.3395L243.759 62.314L245.83 73.5266L247.884 61.7499L255.455 60.7187V82.7509L250.668 83.4061V67.5101L248.124 83.7536L248.129 83.7593Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M257.897 82.4202V60.388L262.655 59.7385V81.7764L257.897 82.4259V82.4202Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M277.173 57.756V79.7938L272.358 80.4491L269.893 69.7606V80.7852L265.078 81.4404V59.4082L270.144 58.7188L272.409 68.9515V58.4112L277.167 57.7616L277.173 57.756Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M289.531 78.1016L288.692 76.3468C287.814 77.8794 286.462 78.7682 284.636 79.0189C281.082 79.5032 279.308 77.4749 279.308 72.9283V63.385C279.308 62.3423 279.45 61.4136 279.73 60.6046C280.009 59.7899 280.352 59.146 280.757 58.6732C281.162 58.2003 281.658 57.7957 282.246 57.4653C282.833 57.1348 283.369 56.9069 283.849 56.7702C284.328 56.6335 284.847 56.5309 285.406 56.4511C286.096 56.3543 286.724 56.3201 287.283 56.3429C287.842 56.3657 288.327 56.4454 288.732 56.5936C289.137 56.7417 289.497 56.9183 289.805 57.1291C290.113 57.3399 290.364 57.6191 290.569 57.9667C290.769 58.3142 290.934 58.6618 291.06 59.0093C291.185 59.3569 291.282 59.7785 291.345 60.2855C291.408 60.7869 291.453 61.2598 291.476 61.6985C291.499 62.1372 291.511 62.6557 291.511 63.2596L286.81 63.9035V62.16C286.81 61.8125 286.77 61.5219 286.696 61.3054C286.621 61.0832 286.513 60.9351 286.382 60.8553C286.245 60.7755 286.125 60.7299 286.011 60.7129C285.897 60.6958 285.771 60.6958 285.634 60.7129C285.355 60.7527 285.127 60.8211 284.955 60.918C284.784 61.0148 284.647 61.1288 284.55 61.2484C284.453 61.3738 284.379 61.5846 284.334 61.8808C284.288 62.1771 284.259 62.4563 284.248 62.7127C284.237 62.9691 284.237 63.3793 284.237 63.9319V72.4554C284.237 72.7801 284.248 73.0479 284.271 73.2644C284.294 73.4809 284.345 73.7145 284.431 73.9595C284.516 74.2045 284.653 74.3811 284.841 74.4894C285.03 74.5976 285.275 74.6318 285.577 74.5919C286.074 74.5236 286.399 74.29 286.564 73.8855C286.73 73.4809 286.81 72.8485 286.81 71.9939V69.4471L285.497 69.6294V65.8235L291.459 65.0088V77.8452L289.542 78.1073L289.531 78.1016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M246.138 96.025V125.282L308.316 116.787L316.976 124.25V115.607V113.157V86.3507L246.138 96.025Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M246.422 95.7402V124.997L308.607 116.502L317.261 123.966V115.317V112.867V86.0659L246.422 95.7402Z",
    fill: "#F7F8F9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M246.713 95.4552V124.706L308.892 116.217L317.552 123.681V115.032V112.582V85.7809L246.713 95.4552Z",
    fill: "#EFF0F3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M246.999 95.1646V124.421L309.178 115.926L317.838 123.39V114.747V112.297V85.4903L246.999 95.1646Z",
    fill: "#E6E9ED"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M247.284 94.8799V124.137L309.468 115.642L318.123 123.105V114.456V112.007V85.2055L247.284 94.8799Z",
    fill: "#DEE2E7"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M247.569 94.595V123.846L309.753 115.357L318.408 122.82V114.172V111.722V84.9206L247.569 94.595Z",
    fill: "#D6DAE1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M247.861 94.3101V123.561L310.039 115.066L318.7 122.53V113.887V111.437V84.6301L247.861 94.3101Z",
    fill: "#CED3DB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M248.146 94.0195V123.276L310.33 114.781L318.984 122.245V113.596V111.146V84.3452L248.146 94.0195Z",
    fill: "#C5CCD5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M248.43 93.7346V122.986L310.615 114.496L319.269 121.96V113.311V110.861V84.0602L248.43 93.7346Z",
    fill: "#BDC4CF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M248.722 93.4497V122.701L310.901 114.206L319.561 121.669V113.026V110.576V83.7697L248.722 93.4497Z",
    fill: "#B5BDC9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M249.006 93.1591V122.416L311.19 113.921L319.845 121.384V112.741V110.286V83.4848L249.006 93.1591Z",
    fill: "#ADB5C3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M249.293 92.8744V122.125L311.477 113.636L320.132 121.1V112.451V110.001V83.2L249.293 92.8744Z",
    fill: "#A5AEBD"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M249.584 92.5895V121.84L311.762 113.345L320.423 120.809V112.166V109.716V82.9095L249.584 92.5895Z",
    fill: "#9CA7B7"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M249.869 92.2989V121.555L312.047 113.061L320.707 120.524V111.881V109.431V82.6245L249.869 92.2989Z",
    fill: "#949FB1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M250.154 92.014V121.271L312.339 112.776L320.993 120.239V111.591V109.141V82.3396L250.154 92.014Z",
    fill: "#8C98AB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M250.444 91.7291V120.98L312.623 112.491L321.283 119.954V111.306V108.856V82.0547L250.444 91.7291Z",
    fill: "#8491A5"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M250.73 91.4385V120.695L312.909 112.2L321.569 119.664V111.021V108.571V81.7642L250.73 91.4385Z",
    fill: "#7B899F"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M251.016 91.1537V120.41L313.2 111.915L321.855 119.379V110.73V108.28V81.4794L251.016 91.1537Z",
    fill: "#738299"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M251.301 90.8689V120.12L313.485 111.631L322.139 119.094V110.445V107.996V81.1945L251.301 90.8689Z",
    fill: "#6B7B93"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M251.592 90.5838V119.835L313.77 111.34L322.43 118.804V110.16V107.711V80.9038L251.592 90.5838Z",
    fill: "#63738D"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M251.876 90.2934V119.55L314.061 111.055L322.715 118.519V109.87V107.42V80.619L251.876 90.2934Z",
    fill: "#5A6C87"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M252.162 90.0084V119.259L314.347 110.77L323.001 118.234V109.585V107.135V80.334L252.162 90.0084Z",
    fill: "#526581"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M252.453 89.7236V118.975L314.632 110.48L323.292 117.943V109.3V106.85V80.0435L252.453 89.7236Z",
    fill: "#4A5D7B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M252.738 89.433V118.69L314.922 110.195L323.577 117.658V109.015V106.56V79.7587L252.738 89.433Z",
    fill: "#425675"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M253.024 89.1481V118.399L315.208 109.91L323.863 117.373V108.725V106.275V79.4738L253.024 89.1481Z",
    fill: "#3A4E6F"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M253.314 88.8634V118.114L315.492 109.619L324.152 117.083V108.44V105.99V79.1833L253.314 88.8634Z",
    fill: "#314769"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M253.6 88.5726V117.829L315.778 109.334L324.438 116.798V108.155V105.705V78.8983L253.6 88.5726Z",
    fill: "#294063"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M253.885 88.2879V117.544L316.07 109.05L324.724 116.513V107.864V105.415V78.6135L253.885 88.2879Z",
    fill: "#21385D"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M254.175 88.003V117.254L316.354 108.765L325.014 116.228V107.58V105.13V78.3286L254.175 88.003Z",
    fill: "#193157"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M254.46 87.7125V116.969L316.639 108.474L325.299 115.938V107.295V104.845V78.0382L254.46 87.7125Z",
    fill: "#102A51"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M254.747 87.4275V116.684L316.931 108.189L325.586 115.653V107.004V104.554V77.7531L254.747 87.4275Z",
    fill: "#08224B"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M255.033 87.1427V116.394L317.217 107.904L325.871 115.368V106.719V104.269V77.4684L255.033 87.1427Z",
    fill: "#001B45"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M255.032 116.394L325.871 106.719V77.4683L255.032 87.1427V116.394Z",
    fill: "#001B45"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M325.871 104.269V115.368L314.278 105.369L325.871 104.269Z",
    fill: "#001B45"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M268.069 111.095C265.781 111.408 264.155 111.112 263.18 110.212C262.204 109.312 261.719 107.785 261.719 105.625V103.466L266.586 102.799V104.776C266.586 106.195 266.979 106.856 267.761 106.748C268.126 106.697 268.411 106.52 268.622 106.218C268.833 105.91 268.936 105.534 268.936 105.084C268.936 104.492 268.856 104.007 268.691 103.626C268.525 103.244 268.28 102.891 267.949 102.572C267.618 102.252 267.076 101.819 266.317 101.278L264.235 99.7798C262.558 98.5776 261.719 97.0792 261.719 95.2845C261.719 93.3302 262.227 91.8033 263.237 90.7151C264.247 89.6211 265.639 88.9545 267.413 88.7152C267.458 88.7095 267.504 88.7038 267.538 88.6982C267.578 88.6982 267.824 88.6583 268.28 88.5956C268.736 88.5329 269.324 88.5557 270.043 88.664C270.762 88.7722 271.401 89.0343 271.96 89.4388C272.519 89.849 272.941 90.4644 273.22 91.2848C273.5 92.111 273.643 93.1422 273.643 94.3899L268.651 95.0736L268.622 93.7518C268.611 93.5068 268.502 93.296 268.303 93.1308C268.097 92.9656 267.869 92.8972 267.618 92.9314C267.293 92.977 267.013 93.1137 266.785 93.3416C266.557 93.5695 266.443 93.843 266.443 94.1563C266.443 94.7831 266.905 95.4041 267.829 96.0137L270.807 97.9851C271.292 98.3041 271.714 98.6403 272.074 98.9935C272.433 99.3468 272.718 99.7057 272.93 100.065C273.141 100.429 273.312 100.76 273.443 101.062C273.574 101.364 273.665 101.694 273.717 102.064C273.768 102.429 273.797 102.708 273.808 102.896C273.82 103.084 273.82 103.329 273.82 103.637C273.82 104.412 273.768 105.124 273.665 105.768C273.563 106.412 273.38 107.05 273.118 107.671C272.855 108.292 272.513 108.827 272.091 109.277C271.669 109.728 271.115 110.115 270.442 110.434C269.763 110.759 268.982 110.981 268.086 111.101L268.069 111.095Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M275.274 103.91V93.4099C275.274 91.5753 275.776 90.0826 276.78 88.9374C277.784 87.7922 279.29 87.0686 281.304 86.761C283.375 86.5046 284.909 86.8122 285.913 87.6896C286.918 88.5614 287.42 89.9174 287.42 91.752V102.252C287.42 103.147 287.305 103.979 287.077 104.742C286.849 105.506 286.501 106.206 286.033 106.845C285.565 107.483 284.938 108.007 284.139 108.434C283.341 108.862 282.428 109.124 281.389 109.238C280.3 109.414 279.353 109.403 278.554 109.198C277.755 108.993 277.122 108.639 276.66 108.127C276.192 107.619 275.844 107.016 275.616 106.309C275.388 105.608 275.274 104.811 275.274 103.916V103.91ZM281.344 104.919C281.521 104.896 281.675 104.839 281.812 104.754C281.948 104.668 282.051 104.543 282.131 104.389C282.211 104.235 282.274 104.093 282.319 103.956C282.365 103.819 282.399 103.643 282.416 103.426C282.433 103.21 282.445 103.039 282.451 102.925C282.451 102.811 282.456 102.651 282.456 102.446V93.484C282.456 93.427 282.456 93.3188 282.462 93.1535C282.462 92.9883 282.462 92.863 282.462 92.7775C282.462 92.692 282.451 92.5724 282.445 92.4129C282.445 92.2533 282.428 92.128 282.405 92.0425C282.382 91.9571 282.354 91.8545 282.319 91.7235C282.285 91.5924 282.245 91.5013 282.188 91.4386C282.131 91.3759 282.068 91.3133 281.994 91.2449C281.92 91.1765 281.829 91.1366 281.715 91.1195C281.6 91.1024 281.475 91.1024 281.338 91.1195C281.144 91.148 280.973 91.205 280.825 91.2848C280.682 91.3702 280.568 91.4899 280.482 91.6437C280.397 91.7975 280.328 91.9343 280.271 92.0596C280.214 92.185 280.18 92.3559 280.157 92.5895C280.14 92.8174 280.129 92.9826 280.129 93.0795V102.606C280.129 102.811 280.129 102.97 280.134 103.09C280.134 103.21 280.151 103.381 280.169 103.608C280.186 103.836 280.22 104.019 280.271 104.155C280.323 104.292 280.391 104.435 280.477 104.577C280.562 104.725 280.676 104.822 280.819 104.885C280.962 104.942 281.133 104.959 281.332 104.93L281.344 104.919Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M289.262 102.002V91.5014C289.262 89.6668 289.764 88.1741 290.769 87.0289C291.773 85.8837 293.279 85.1601 295.293 84.8524C297.364 84.5961 298.898 84.9037 299.902 85.7811C300.906 86.6529 301.408 88.0089 301.408 89.8434V100.344C301.408 101.238 301.294 102.07 301.066 102.834C300.838 103.597 300.49 104.298 300.022 104.93C299.554 105.569 298.927 106.093 298.128 106.52C297.329 106.942 296.416 107.209 295.378 107.323C294.289 107.5 293.342 107.489 292.543 107.283C291.744 107.078 291.117 106.725 290.649 106.212C290.181 105.705 289.833 105.101 289.605 104.395C289.377 103.694 289.262 102.896 289.262 102.002ZM295.333 103.01C295.509 102.988 295.663 102.931 295.8 102.845C295.937 102.76 296.04 102.634 296.12 102.48C296.2 102.327 296.262 102.184 296.308 102.047C296.354 101.911 296.388 101.734 296.405 101.518C296.422 101.295 296.434 101.13 296.439 101.016C296.439 100.902 296.445 100.743 296.445 100.538V91.5755C296.445 91.5185 296.445 91.4103 296.451 91.245C296.451 91.0798 296.451 90.9545 296.451 90.869C296.451 90.7835 296.439 90.6639 296.439 90.5044C296.439 90.3448 296.422 90.2195 296.399 90.134C296.377 90.0486 296.348 89.9403 296.314 89.815C296.28 89.6839 296.24 89.5928 296.183 89.5301C296.126 89.4674 296.063 89.4047 295.989 89.3364C295.914 89.268 295.823 89.2281 295.709 89.211C295.595 89.1939 295.469 89.1939 295.333 89.211C295.139 89.2395 294.967 89.2965 294.819 89.3762C294.676 89.4617 294.562 89.5814 294.477 89.7352C294.391 89.889 294.323 90.0258 294.266 90.1511C294.209 90.2765 294.174 90.4474 294.152 90.681C294.135 90.9089 294.123 91.0741 294.123 91.171V100.697C294.123 100.902 294.123 101.062 294.129 101.181C294.129 101.301 294.146 101.472 294.163 101.7C294.18 101.928 294.214 102.11 294.266 102.247C294.317 102.384 294.386 102.526 294.471 102.668C294.557 102.817 294.671 102.913 294.813 102.976C294.956 103.033 295.127 103.05 295.327 103.022L295.333 103.01Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M315.637 82.3113V104.349L310.822 105.004L308.357 94.3159V105.341L303.542 105.996V83.9635L308.608 83.2742L310.873 93.5068V82.9665L315.631 82.317L315.637 82.3113Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M298.394 44.5548C297.966 44.6175 297.618 45.0163 297.618 45.4437C297.618 45.871 297.966 46.1672 298.394 46.1046C298.822 46.0419 299.17 45.6431 299.17 45.2158C299.17 44.7884 298.822 44.4922 298.394 44.5548Z",
    fill: "url(#paint2_linear_13970_23982)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M296.757 44.7941C296.329 44.8567 295.981 45.2556 295.981 45.6829C295.981 46.1102 296.329 46.4065 296.757 46.3438C297.185 46.2811 297.533 45.8823 297.533 45.455C297.533 45.0277 297.185 44.7314 296.757 44.7941Z",
    fill: "url(#paint3_linear_13970_23982)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M295.121 45.056C294.704 45.1187 294.362 45.5061 294.362 45.9277C294.362 46.3494 294.704 46.6342 295.121 46.5716C295.537 46.5089 295.88 46.1215 295.88 45.6998C295.88 45.2782 295.537 44.9934 295.121 45.056Z",
    fill: "url(#paint4_linear_13970_23982)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M293.477 45.3125C293.066 45.3751 292.735 45.7512 292.735 46.1614C292.735 46.5716 293.066 46.8508 293.477 46.7938C293.887 46.7311 294.218 46.3551 294.218 45.9449C294.218 45.5347 293.887 45.2555 293.477 45.3125Z",
    fill: "url(#paint5_linear_13970_23982)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M291.84 45.5745C291.44 45.6315 291.115 46.0018 291.115 46.4007C291.115 46.7995 291.44 47.073 291.84 47.016C292.239 46.959 292.564 46.5887 292.564 46.1899C292.564 45.791 292.239 45.5175 291.84 45.5745Z",
    fill: "url(#paint6_linear_13970_23982)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M290.202 45.8366C289.814 45.8936 289.5 46.2582 289.5 46.6456C289.5 47.0331 289.814 47.3008 290.202 47.2439C290.59 47.1869 290.904 46.8223 290.904 46.4348C290.904 46.0474 290.59 45.7796 290.202 45.8366Z",
    fill: "url(#paint7_linear_13970_23982)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M288.558 46.0987C288.182 46.1557 287.88 46.5032 287.88 46.8793C287.88 47.2553 288.182 47.5174 288.558 47.4604C288.935 47.4034 289.237 47.0559 289.237 46.6798C289.237 46.3038 288.935 46.0417 288.558 46.0987Z",
    fill: "url(#paint8_linear_13970_23982)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M286.923 46.3609C286.558 46.4179 286.262 46.754 286.262 47.1244C286.262 47.4947 286.558 47.7454 286.923 47.6884C287.289 47.6372 287.585 47.2953 287.585 46.925C287.585 46.5546 287.289 46.3039 286.923 46.3609Z",
    fill: "url(#paint9_linear_13970_23982)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M285.284 46.623C284.931 46.6743 284.64 47.0047 284.64 47.3637C284.64 47.7226 284.931 47.9676 285.284 47.9106C285.638 47.8594 285.929 47.5289 285.929 47.17C285.929 46.811 285.638 46.566 285.284 46.623Z",
    fill: "url(#paint10_linear_13970_23982)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M283.647 46.8793C283.299 46.9305 283.02 47.2496 283.02 47.5971C283.02 47.9447 283.299 48.184 283.647 48.1327C283.995 48.0814 284.275 47.7624 284.275 47.4148C284.275 47.0673 283.995 46.828 283.647 46.8793Z",
    fill: "url(#paint11_linear_13970_23982)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M282.004 47.1413C281.668 47.1926 281.394 47.506 281.394 47.8421C281.394 48.1783 281.668 48.4119 282.004 48.3606C282.341 48.3093 282.615 47.996 282.615 47.6598C282.615 47.3237 282.341 47.0901 282.004 47.1413Z",
    fill: "url(#paint12_linear_13970_23982)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M280.367 47.4035C280.042 47.449 279.774 47.7567 279.774 48.0815C279.774 48.4062 280.036 48.6341 280.367 48.5828C280.692 48.5373 280.961 48.2296 280.961 47.9048C280.961 47.5801 280.698 47.3522 280.367 47.4035Z",
    fill: "url(#paint13_linear_13970_23982)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M278.731 47.6598C278.417 47.7054 278.16 48.0017 278.16 48.315C278.16 48.6284 278.417 48.8506 278.731 48.805C279.045 48.7594 279.301 48.4632 279.301 48.1498C279.301 47.8365 279.045 47.6143 278.731 47.6598Z",
    fill: "url(#paint14_linear_13970_23982)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M277.092 47.9221C276.784 47.9676 276.538 48.2525 276.538 48.5602C276.538 48.8678 276.789 49.0786 277.092 49.0331C277.4 48.9875 277.645 48.7026 277.645 48.3949C277.645 48.0873 277.394 47.8765 277.092 47.9221Z",
    fill: "url(#paint15_linear_13970_23982)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M275.449 48.1841C275.158 48.2297 274.918 48.5032 274.918 48.7938C274.918 49.0843 275.158 49.2895 275.449 49.2439C275.74 49.1983 275.98 48.9248 275.98 48.6342C275.98 48.3437 275.74 48.1386 275.449 48.1841Z",
    fill: "url(#paint16_linear_13970_23982)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M273.813 48.4461C273.528 48.486 273.3 48.7538 273.3 49.0329C273.3 49.3121 273.528 49.5115 273.813 49.4716C274.098 49.4318 274.326 49.164 274.326 48.8848C274.326 48.6056 274.098 48.4062 273.813 48.4461Z",
    fill: "url(#paint17_linear_13970_23982)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M272.175 48.7082C271.901 48.7481 271.679 49.0045 271.679 49.2779C271.679 49.5514 271.901 49.7394 272.175 49.6995C272.449 49.6597 272.671 49.4033 272.671 49.1298C272.671 48.8563 272.449 48.6683 272.175 48.7082Z",
    fill: "url(#paint18_linear_13970_23982)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M270.532 48.9646C270.269 49.0045 270.053 49.2495 270.053 49.5115C270.053 49.7736 270.264 49.9559 270.532 49.9161C270.794 49.8762 271.011 49.6312 271.011 49.3691C271.011 49.107 270.8 48.9247 270.532 48.9646Z",
    fill: "url(#paint19_linear_13970_23982)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M268.894 49.2267C268.643 49.2666 268.438 49.5002 268.438 49.7509C268.438 50.0016 268.643 50.1782 268.894 50.144C269.145 50.1041 269.351 49.8705 269.351 49.6198C269.351 49.3691 269.145 49.1925 268.894 49.2267Z",
    fill: "url(#paint20_linear_13970_23982)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M267.257 49.4888C267.012 49.5229 266.818 49.7508 266.818 49.9958C266.818 50.2408 267.018 50.4061 267.257 50.3719C267.503 50.3377 267.697 50.1098 267.697 49.8648C267.697 49.6198 267.497 49.4546 267.257 49.4888Z",
    fill: "url(#paint21_linear_13970_23982)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M265.619 49.7451C265.385 49.7793 265.197 49.9958 265.197 50.2294C265.197 50.463 265.385 50.6226 265.619 50.5884C265.853 50.5542 266.041 50.3377 266.041 50.1041C266.041 49.8705 265.853 49.711 265.619 49.7451Z",
    fill: "url(#paint22_linear_13970_23982)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M263.977 50.0072C263.755 50.0414 263.572 50.2465 263.572 50.4687C263.572 50.6909 263.755 50.8448 263.977 50.8106C264.2 50.7764 264.382 50.5713 264.382 50.3491C264.382 50.1269 264.2 49.973 263.977 50.0072Z",
    fill: "url(#paint23_linear_13970_23982)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M262.339 50.2693C262.128 50.3035 261.951 50.4972 261.951 50.7137C261.951 50.9302 262.122 51.0727 262.339 51.0442C262.556 51.0157 262.727 50.8163 262.727 50.5998C262.727 50.3833 262.556 50.2408 262.339 50.2693Z",
    fill: "url(#paint24_linear_13970_23982)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M260.702 50.5313C260.503 50.5598 260.337 50.7478 260.337 50.9472C260.337 51.1467 260.503 51.2891 260.702 51.2549C260.902 51.2264 261.068 51.0384 261.068 50.839C261.068 50.6396 260.902 50.4971 260.702 50.5313Z",
    fill: "url(#paint25_linear_13970_23982)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M259.059 50.7934C258.871 50.8219 258.711 50.9985 258.711 51.1865C258.711 51.3745 258.865 51.5113 259.059 51.4828C259.248 51.4543 259.407 51.2777 259.407 51.0896C259.407 50.9016 259.253 50.7649 259.059 50.7934Z",
    fill: "url(#paint26_linear_13970_23982)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 51.0499C257.239 51.0784 257.097 51.2436 257.097 51.4259C257.097 51.6083 257.245 51.7336 257.422 51.7051C257.604 51.6766 257.747 51.5114 257.747 51.3291C257.747 51.1468 257.599 51.0214 257.422 51.0499Z",
    fill: "url(#paint27_linear_13970_23982)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M255.785 51.3119C255.614 51.3347 255.477 51.4942 255.477 51.6651C255.477 51.836 255.614 51.9557 255.785 51.9272C255.956 51.9044 256.093 51.7449 256.093 51.574C256.093 51.403 255.956 51.2834 255.785 51.3119Z",
    fill: "url(#paint28_linear_13970_23982)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M254.148 51.574C253.988 51.5968 253.857 51.745 253.857 51.9102C253.857 52.0754 253.988 52.1837 254.148 52.1552C254.308 52.1324 254.439 51.9843 254.439 51.819C254.439 51.6538 254.308 51.5455 254.148 51.574Z",
    fill: "url(#paint29_linear_13970_23982)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M252.504 51.8305C252.355 51.8533 252.23 51.99 252.23 52.1438C252.23 52.2977 252.35 52.4002 252.504 52.3774C252.652 52.3546 252.777 52.2179 252.777 52.0641C252.777 51.9102 252.658 51.8077 252.504 51.8305Z",
    fill: "url(#paint30_linear_13970_23982)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M250.868 52.0926C250.725 52.1154 250.611 52.2464 250.611 52.3831C250.611 52.5199 250.725 52.6224 250.868 52.5996C251.01 52.5769 251.124 52.4458 251.124 52.3091C251.124 52.1723 251.01 52.0698 250.868 52.0926Z",
    fill: "url(#paint31_linear_13970_23982)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 52.3547C249.099 52.3718 248.996 52.4971 248.996 52.6282C248.996 52.7592 249.105 52.8504 249.23 52.8276C249.361 52.8105 249.464 52.6851 249.464 52.5541C249.464 52.4231 249.356 52.3319 249.23 52.3547Z",
    fill: "url(#paint32_linear_13970_23982)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M247.586 52.6109C247.466 52.628 247.369 52.742 247.369 52.8616C247.369 52.9812 247.466 53.0667 247.586 53.0496C247.706 53.0325 247.803 52.9186 247.803 52.7989C247.803 52.6793 247.706 52.5938 247.586 52.6109Z",
    fill: "url(#paint33_linear_13970_23982)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M245.949 52.8731C245.84 52.8902 245.749 52.9928 245.749 53.101C245.749 53.2093 245.84 53.289 245.949 53.272C246.057 53.2549 246.148 53.1523 246.148 53.0441C246.148 52.9358 246.057 52.856 245.949 52.8731Z",
    fill: "url(#paint34_linear_13970_23982)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M244.311 53.1351C244.208 53.1522 244.128 53.2434 244.128 53.3459C244.128 53.4485 244.208 53.5169 244.311 53.4998C244.413 53.4827 244.493 53.3915 244.493 53.289C244.493 53.1864 244.413 53.118 244.311 53.1351Z",
    fill: "url(#paint35_linear_13970_23982)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M242.675 53.3915C242.584 53.4028 242.509 53.4883 242.509 53.5795C242.509 53.6706 242.584 53.7333 242.675 53.7162C242.766 53.6991 242.84 53.6194 242.84 53.5282C242.84 53.437 242.766 53.3744 242.675 53.3915Z",
    fill: "url(#paint36_linear_13970_23982)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M241.031 53.6536C240.951 53.665 240.888 53.739 240.888 53.8188C240.888 53.8986 240.951 53.9555 241.031 53.9442C241.111 53.9328 241.174 53.8587 241.174 53.7789C241.174 53.6992 241.111 53.6422 241.031 53.6536Z",
    fill: "url(#paint37_linear_13970_23982)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M239.393 53.9214C239.325 53.9328 239.268 53.9954 239.268 54.0638C239.268 54.1322 239.325 54.1777 239.393 54.1664C239.462 54.155 239.519 54.0923 239.519 54.0239C239.519 53.9555 239.462 53.91 239.393 53.9214Z",
    fill: "url(#paint38_linear_13970_23982)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M237.757 54.1778C237.699 54.1835 237.654 54.2405 237.654 54.2975C237.654 54.3545 237.699 54.3944 237.757 54.3887C237.814 54.383 237.859 54.326 237.859 54.269C237.859 54.212 237.814 54.1722 237.757 54.1778Z",
    fill: "url(#paint39_linear_13970_23982)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M236.119 54.4399C236.073 54.4456 236.033 54.4911 236.033 54.5367C236.033 54.5823 236.073 54.6165 236.119 54.6108C236.164 54.6051 236.204 54.5595 236.204 54.5139C236.204 54.4683 236.164 54.4342 236.119 54.4399Z",
    fill: "url(#paint40_linear_13970_23982)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 54.702C234.437 54.702 234.409 54.7419 234.409 54.7818C234.409 54.8217 234.437 54.8445 234.477 54.8388C234.517 54.8388 234.546 54.7989 234.546 54.759C234.546 54.7191 234.517 54.6963 234.477 54.702Z",
    fill: "url(#paint41_linear_13970_23982)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M232.838 54.9584C232.838 54.9584 232.787 54.9869 232.787 55.0154C232.787 55.0439 232.81 55.061 232.838 55.0553C232.867 55.0496 232.89 55.0268 232.89 54.9983C232.89 54.9698 232.867 54.9527 232.838 54.9584Z",
    fill: "url(#paint42_linear_13970_23982)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M231.201 55.2204C231.201 55.2204 231.166 55.2379 231.166 55.2554C231.166 55.2728 231.184 55.2845 231.201 55.2845C231.219 55.2845 231.236 55.267 231.236 55.2495C231.236 55.2321 231.219 55.2204 231.201 55.2204Z",
    fill: "url(#paint43_linear_13970_23982)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M229.559 55.4825C229.559 55.4825 229.547 55.4884 229.547 55.5001C229.547 55.5119 229.553 55.5119 229.559 55.5119C229.565 55.5119 229.571 55.506 229.571 55.4943C229.571 55.4825 229.565 55.4825 229.559 55.4825Z",
    fill: "url(#paint44_linear_13970_23982)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M298.394 42.9139C297.966 42.9766 297.618 43.3754 297.618 43.8027C297.618 44.23 297.966 44.5263 298.394 44.4636C298.822 44.401 299.17 44.0021 299.17 43.5748C299.17 43.1475 298.822 42.8512 298.394 42.9139Z",
    fill: "url(#paint45_linear_13970_23982)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M296.757 43.1588C296.329 43.2215 295.981 43.6203 295.981 44.0477C295.981 44.475 296.329 44.7712 296.757 44.7086C297.185 44.6459 297.533 44.2471 297.533 43.8198C297.533 43.3924 297.185 43.0962 296.757 43.1588Z",
    fill: "url(#paint46_linear_13970_23982)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M295.121 43.4153C294.704 43.4779 294.362 43.8654 294.362 44.287C294.362 44.7086 294.704 44.9935 295.121 44.9308C295.537 44.8681 295.88 44.4807 295.88 44.0591C295.88 43.6375 295.537 43.3526 295.121 43.4153Z",
    fill: "url(#paint47_linear_13970_23982)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M293.477 43.6772C293.066 43.7399 292.735 44.1159 292.735 44.5262C292.735 44.9364 293.066 45.2156 293.477 45.1586C293.887 45.0959 294.218 44.7199 294.218 44.3097C294.218 43.8994 293.887 43.6203 293.477 43.6772Z",
    fill: "url(#paint48_linear_13970_23982)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M291.84 43.9394C291.44 43.9964 291.115 44.3667 291.115 44.7656C291.115 45.1644 291.44 45.4379 291.84 45.3809C292.239 45.3239 292.564 44.9536 292.564 44.5547C292.564 44.1559 292.239 43.8824 291.84 43.9394Z",
    fill: "url(#paint49_linear_13970_23982)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M290.202 44.1957C289.814 44.2527 289.5 44.6173 289.5 45.0047C289.5 45.3922 289.814 45.6599 290.202 45.603C290.59 45.546 290.904 45.1814 290.904 44.7939C290.904 44.4065 290.59 44.1387 290.202 44.1957Z",
    fill: "url(#paint50_linear_13970_23982)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M288.558 44.4636C288.182 44.5206 287.88 44.8681 287.88 45.2442C287.88 45.6202 288.182 45.8823 288.558 45.8253C288.935 45.7683 289.237 45.4208 289.237 45.0447C289.237 44.6687 288.935 44.4066 288.558 44.4636Z",
    fill: "url(#paint51_linear_13970_23982)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M286.923 44.7255C286.558 44.7825 286.262 45.1187 286.262 45.489C286.262 45.8593 286.558 46.11 286.923 46.0531C287.289 45.9961 287.585 45.6599 287.585 45.2896C287.585 44.9193 287.289 44.6686 286.923 44.7255Z",
    fill: "url(#paint52_linear_13970_23982)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M285.284 44.9821C284.931 45.0334 284.64 45.3638 284.64 45.7228C284.64 46.0817 284.931 46.3267 285.284 46.2697C285.638 46.2185 285.929 45.888 285.929 45.5291C285.929 45.1701 285.638 44.9251 285.284 44.9821Z",
    fill: "url(#paint53_linear_13970_23982)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M283.647 45.244C283.299 45.2953 283.02 45.6144 283.02 45.9619C283.02 46.3095 283.299 46.5488 283.647 46.4975C283.995 46.4462 284.275 46.1272 284.275 45.7796C284.275 45.4321 283.995 45.1928 283.647 45.244Z",
    fill: "url(#paint54_linear_13970_23982)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M282.004 45.5062C281.668 45.5575 281.394 45.8709 281.394 46.207C281.394 46.5432 281.668 46.7768 282.004 46.7255C282.341 46.6742 282.615 46.3609 282.615 46.0247C282.615 45.6886 282.341 45.455 282.004 45.5062Z",
    fill: "url(#paint55_linear_13970_23982)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M280.367 45.7625C280.042 45.8081 279.774 46.1158 279.774 46.4405C279.774 46.7653 280.036 46.9932 280.367 46.9419C280.692 46.8963 280.961 46.5887 280.961 46.2639C280.961 45.9391 280.698 45.7112 280.367 45.7625Z",
    fill: "url(#paint56_linear_13970_23982)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M278.731 46.0247C278.417 46.0703 278.16 46.3666 278.16 46.6799C278.16 46.9933 278.417 47.2155 278.731 47.1699C279.045 47.1243 279.301 46.8281 279.301 46.5147C279.301 46.2014 279.045 45.9792 278.731 46.0247Z",
    fill: "url(#paint57_linear_13970_23982)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M277.092 46.2868C276.784 46.3324 276.538 46.6173 276.538 46.9249C276.538 47.2326 276.789 47.4434 277.092 47.3978C277.4 47.3522 277.645 47.0674 277.645 46.7597C277.645 46.452 277.394 46.2412 277.092 46.2868Z",
    fill: "url(#paint58_linear_13970_23982)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M275.449 46.5488C275.158 46.5943 274.918 46.8678 274.918 47.1584C274.918 47.449 275.158 47.6541 275.449 47.6085C275.74 47.5629 275.98 47.2894 275.98 46.9989C275.98 46.7083 275.74 46.5032 275.449 46.5488Z",
    fill: "url(#paint59_linear_13970_23982)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M273.813 46.811C273.528 46.8509 273.3 47.1187 273.3 47.3978C273.3 47.677 273.528 47.8764 273.813 47.8365C274.098 47.7967 274.326 47.5289 274.326 47.2497C274.326 46.9705 274.098 46.7711 273.813 46.811Z",
    fill: "url(#paint60_linear_13970_23982)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M272.175 47.0674C271.901 47.1073 271.679 47.3637 271.679 47.6372C271.679 47.9106 271.901 48.0987 272.175 48.0588C272.449 48.0189 272.671 47.7625 272.671 47.489C272.671 47.2155 272.449 47.0275 272.175 47.0674Z",
    fill: "url(#paint61_linear_13970_23982)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M270.532 47.3295C270.269 47.3694 270.053 47.6144 270.053 47.8764C270.053 48.1385 270.264 48.3208 270.532 48.281C270.794 48.2411 271.011 47.9961 271.011 47.734C271.011 47.4719 270.8 47.2896 270.532 47.3295Z",
    fill: "url(#paint62_linear_13970_23982)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M268.894 47.5915C268.643 47.6313 268.438 47.8649 268.438 48.1156C268.438 48.3663 268.643 48.5429 268.894 48.5087C269.145 48.4689 269.351 48.2353 269.351 47.9846C269.351 47.7339 269.145 47.5573 268.894 47.5915Z",
    fill: "url(#paint63_linear_13970_23982)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M267.257 47.8479C267.012 47.882 266.818 48.1099 266.818 48.3549C266.818 48.5999 267.018 48.7652 267.257 48.731C267.503 48.6968 267.697 48.4689 267.697 48.2239C267.697 47.9789 267.497 47.8137 267.257 47.8479Z",
    fill: "url(#paint64_linear_13970_23982)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M265.619 48.11C265.385 48.1442 265.197 48.3607 265.197 48.5943C265.197 48.8279 265.385 48.9875 265.619 48.9533C265.853 48.9191 266.041 48.7026 266.041 48.469C266.041 48.2354 265.853 48.0759 265.619 48.11Z",
    fill: "url(#paint65_linear_13970_23982)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M263.977 48.3721C263.755 48.4063 263.572 48.6114 263.572 48.8336C263.572 49.0558 263.755 49.2097 263.977 49.1755C264.2 49.1413 264.382 48.9362 264.382 48.714C264.382 48.4918 264.2 48.3379 263.977 48.3721Z",
    fill: "url(#paint66_linear_13970_23982)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M262.339 48.6284C262.128 48.6626 261.951 48.8563 261.951 49.0728C261.951 49.2893 262.122 49.4318 262.339 49.4033C262.556 49.3748 262.727 49.1754 262.727 48.9589C262.727 48.7424 262.556 48.5999 262.339 48.6284Z",
    fill: "url(#paint67_linear_13970_23982)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M260.702 48.8963C260.503 48.9248 260.337 49.1128 260.337 49.3123C260.337 49.5117 260.503 49.6541 260.702 49.6199C260.902 49.5914 261.068 49.4034 261.068 49.204C261.068 49.0046 260.902 48.8622 260.702 48.8963Z",
    fill: "url(#paint68_linear_13970_23982)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M259.059 49.1584C258.871 49.1869 258.711 49.3635 258.711 49.5515C258.711 49.7395 258.865 49.8763 259.059 49.8478C259.248 49.8193 259.407 49.6427 259.407 49.4547C259.407 49.2666 259.253 49.1299 259.059 49.1584Z",
    fill: "url(#paint69_linear_13970_23982)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 49.4147C257.239 49.4432 257.097 49.6084 257.097 49.7907C257.097 49.973 257.245 50.0984 257.422 50.0699C257.604 50.0414 257.747 49.8762 257.747 49.6939C257.747 49.5115 257.599 49.3862 257.422 49.4147Z",
    fill: "url(#paint70_linear_13970_23982)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M255.785 49.6769C255.614 49.6997 255.477 49.8592 255.477 50.0301C255.477 50.2011 255.614 50.3207 255.785 50.2922C255.956 50.2694 256.093 50.1099 256.093 49.939C256.093 49.7681 255.956 49.6484 255.785 49.6769Z",
    fill: "url(#paint71_linear_13970_23982)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M254.148 49.9389C253.988 49.9617 253.857 50.1099 253.857 50.2751C253.857 50.4403 253.988 50.5486 254.148 50.5201C254.308 50.4973 254.439 50.3492 254.439 50.1839C254.439 50.0187 254.308 49.9104 254.148 49.9389Z",
    fill: "url(#paint72_linear_13970_23982)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M252.504 50.1952C252.355 50.218 252.23 50.3548 252.23 50.5086C252.23 50.6624 252.35 50.765 252.504 50.7422C252.652 50.7194 252.777 50.5827 252.777 50.4288C252.777 50.275 252.658 50.1725 252.504 50.1952Z",
    fill: "url(#paint73_linear_13970_23982)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M250.868 50.4573C250.725 50.4801 250.611 50.6111 250.611 50.7479C250.611 50.8846 250.725 50.9872 250.868 50.9644C251.01 50.9416 251.124 50.8106 251.124 50.6738C251.124 50.5371 251.01 50.4345 250.868 50.4573Z",
    fill: "url(#paint74_linear_13970_23982)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 50.7194C249.099 50.7365 248.996 50.8619 248.996 50.9929C248.996 51.124 249.105 51.2151 249.23 51.1923C249.356 51.1695 249.464 51.0499 249.464 50.9189C249.464 50.7878 249.356 50.6966 249.23 50.7194Z",
    fill: "url(#paint75_linear_13970_23982)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M247.586 50.9759C247.466 50.993 247.369 51.107 247.369 51.2266C247.369 51.3463 247.466 51.4317 247.586 51.4146C247.706 51.3975 247.803 51.2836 247.803 51.1639C247.803 51.0443 247.706 50.9588 247.586 50.9759Z",
    fill: "url(#paint76_linear_13970_23982)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M245.949 51.2379C245.84 51.255 245.749 51.3576 245.749 51.4658C245.749 51.5741 245.84 51.6538 245.949 51.6367C246.057 51.6196 246.148 51.5171 246.148 51.4088C246.148 51.3006 246.057 51.2208 245.949 51.2379Z",
    fill: "url(#paint77_linear_13970_23982)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M244.311 51.4999C244.208 51.517 244.128 51.6081 244.128 51.7107C244.128 51.8132 244.208 51.8816 244.311 51.8645C244.413 51.8474 244.493 51.7563 244.493 51.6537C244.493 51.5511 244.413 51.4828 244.311 51.4999Z",
    fill: "url(#paint78_linear_13970_23982)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M242.675 51.7562C242.584 51.7676 242.509 51.8531 242.509 51.9442C242.509 52.0354 242.584 52.0981 242.675 52.081C242.766 52.0639 242.84 51.9841 242.84 51.893C242.84 51.8018 242.766 51.7391 242.675 51.7562Z",
    fill: "url(#paint79_linear_13970_23982)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M241.031 52.0185C240.951 52.0299 240.888 52.1039 240.888 52.1837C240.888 52.2635 240.951 52.3204 241.031 52.3091C241.111 52.2977 241.174 52.2236 241.174 52.1438C241.174 52.0641 241.111 52.0071 241.031 52.0185Z",
    fill: "url(#paint80_linear_13970_23982)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M239.393 52.2805C239.325 52.2919 239.268 52.3545 239.268 52.4229C239.268 52.4913 239.325 52.5368 239.393 52.5255C239.462 52.5141 239.519 52.4514 239.519 52.383C239.519 52.3146 239.462 52.2691 239.393 52.2805Z",
    fill: "url(#paint81_linear_13970_23982)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M237.757 52.5426C237.699 52.5483 237.654 52.6053 237.654 52.6622C237.654 52.7192 237.699 52.7591 237.757 52.7534C237.814 52.7477 237.859 52.6907 237.859 52.6338C237.859 52.5768 237.814 52.5369 237.757 52.5426Z",
    fill: "url(#paint82_linear_13970_23982)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M236.119 52.8045C236.073 52.8102 236.033 52.8558 236.033 52.9014C236.033 52.947 236.073 52.9811 236.119 52.9754C236.164 52.9697 236.204 52.9242 236.204 52.8786C236.204 52.833 236.164 52.7988 236.119 52.8045Z",
    fill: "url(#paint83_linear_13970_23982)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 53.061C234.437 53.061 234.409 53.1009 234.409 53.1408C234.409 53.1807 234.437 53.2035 234.477 53.1978C234.517 53.1978 234.546 53.1579 234.546 53.118C234.546 53.0781 234.517 53.0553 234.477 53.061Z",
    fill: "url(#paint84_linear_13970_23982)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M232.838 53.3231C232.838 53.3231 232.787 53.3515 232.787 53.38C232.787 53.4085 232.81 53.4256 232.838 53.4199C232.867 53.4142 232.89 53.3914 232.89 53.3629C232.89 53.3344 232.867 53.3174 232.838 53.3231Z",
    fill: "url(#paint85_linear_13970_23982)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M231.201 53.5853C231.201 53.5853 231.166 53.6028 231.166 53.6203C231.166 53.6377 231.184 53.6494 231.201 53.6494C231.219 53.6494 231.236 53.6319 231.236 53.6144C231.236 53.597 231.219 53.5853 231.201 53.5853Z",
    fill: "url(#paint86_linear_13970_23982)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M229.559 53.8416C229.559 53.8416 229.547 53.8475 229.547 53.8592C229.547 53.871 229.553 53.871 229.559 53.871C229.565 53.871 229.571 53.8651 229.571 53.8534C229.571 53.8416 229.565 53.8416 229.559 53.8416Z",
    fill: "url(#paint87_linear_13970_23982)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M298.394 41.2787C297.966 41.3414 297.618 41.7402 297.618 42.1675C297.618 42.5948 297.966 42.8911 298.394 42.8284C298.822 42.7657 299.17 42.3669 299.17 41.9396C299.17 41.5123 298.822 41.216 298.394 41.2787Z",
    fill: "url(#paint88_linear_13970_23982)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M296.757 41.5236C296.329 41.5863 295.981 41.9851 295.981 42.4124C295.981 42.8397 296.329 43.136 296.757 43.0733C297.185 43.0107 297.533 42.6118 297.533 42.1845C297.533 41.7572 297.185 41.461 296.757 41.5236Z",
    fill: "url(#paint89_linear_13970_23982)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M295.121 41.78C294.704 41.8427 294.362 42.2301 294.362 42.6517C294.362 43.0734 294.704 43.3582 295.121 43.2956C295.537 43.2329 295.88 42.8455 295.88 42.4238C295.88 42.0022 295.537 41.7174 295.121 41.78Z",
    fill: "url(#paint90_linear_13970_23982)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M293.477 42.0423C293.066 42.1049 292.735 42.481 292.735 42.8912C292.735 43.3014 293.066 43.5806 293.477 43.5236C293.887 43.4609 294.218 43.0849 294.218 42.6747C294.218 42.2645 293.887 41.9853 293.477 42.0423Z",
    fill: "url(#paint91_linear_13970_23982)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M291.84 42.3042C291.44 42.3612 291.115 42.7315 291.115 43.1303C291.115 43.5292 291.44 43.8026 291.84 43.7457C292.239 43.6887 292.564 43.3183 292.564 42.9195C292.564 42.5207 292.239 42.2472 291.84 42.3042Z",
    fill: "url(#paint92_linear_13970_23982)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M290.202 42.5606C289.814 42.6176 289.5 42.9822 289.5 43.3696C289.5 43.7571 289.814 44.0248 290.202 43.9679C290.59 43.9109 290.904 43.5463 290.904 43.1588C290.904 42.7714 290.59 42.5036 290.202 42.5606Z",
    fill: "url(#paint93_linear_13970_23982)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M288.558 42.8283C288.182 42.8853 287.88 43.2329 287.88 43.6089C287.88 43.9849 288.182 44.247 288.558 44.19C288.935 44.1331 289.237 43.7855 289.237 43.4095C289.237 43.0334 288.935 42.7714 288.558 42.8283Z",
    fill: "url(#paint94_linear_13970_23982)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M286.923 43.0848C286.558 43.1417 286.262 43.4779 286.262 43.8482C286.262 44.2186 286.558 44.4693 286.923 44.4123C287.289 44.3553 287.585 44.0191 287.585 43.6488C287.585 43.2785 287.289 43.0278 286.923 43.0848Z",
    fill: "url(#paint95_linear_13970_23982)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M285.284 43.3469C284.931 43.3982 284.64 43.7286 284.64 44.0876C284.64 44.4465 284.931 44.6915 285.284 44.6345C285.638 44.5832 285.929 44.2528 285.929 43.8938C285.929 43.5349 285.638 43.2899 285.284 43.3469Z",
    fill: "url(#paint96_linear_13970_23982)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M283.647 43.6091C283.299 43.6603 283.02 43.9794 283.02 44.3269C283.02 44.6745 283.299 44.9138 283.647 44.8625C283.995 44.8112 284.275 44.4922 284.275 44.1446C284.275 43.7971 283.995 43.5578 283.647 43.6091Z",
    fill: "url(#paint97_linear_13970_23982)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M282.004 43.8655C281.668 43.9167 281.394 44.2301 281.394 44.5663C281.394 44.9024 281.668 45.136 282.004 45.0847C282.341 45.0334 282.615 44.7201 282.615 44.3839C282.615 44.0478 282.341 43.8142 282.004 43.8655Z",
    fill: "url(#paint98_linear_13970_23982)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M280.367 44.1274C280.042 44.173 279.774 44.4807 279.774 44.8054C279.774 45.1302 280.036 45.3581 280.367 45.3068C280.692 45.2612 280.961 44.9536 280.961 44.6288C280.961 44.304 280.698 44.0761 280.367 44.1274Z",
    fill: "url(#paint99_linear_13970_23982)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M278.731 44.3895C278.417 44.4351 278.16 44.7314 278.16 45.0447C278.16 45.3581 278.417 45.5803 278.731 45.5347C279.045 45.4891 279.301 45.1929 279.301 44.8795C279.301 44.5661 279.045 44.3439 278.731 44.3895Z",
    fill: "url(#paint100_linear_13970_23982)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M277.092 44.6459C276.784 44.6915 276.538 44.9764 276.538 45.284C276.538 45.5917 276.789 45.8025 277.092 45.7569C277.4 45.7113 277.645 45.4265 277.645 45.1188C277.645 44.8111 277.394 44.6003 277.092 44.6459Z",
    fill: "url(#paint101_linear_13970_23982)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M275.449 44.9138C275.158 44.9594 274.918 45.2329 274.918 45.5234C274.918 45.814 275.158 46.0191 275.449 45.9735C275.74 45.928 275.98 45.6545 275.98 45.3639C275.98 45.0733 275.74 44.8682 275.449 44.9138Z",
    fill: "url(#paint102_linear_13970_23982)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M273.813 45.17C273.528 45.2099 273.3 45.4776 273.3 45.7568C273.3 46.036 273.528 46.2354 273.813 46.1955C274.098 46.1556 274.326 45.8879 274.326 45.6087C274.326 45.3295 274.098 45.1301 273.813 45.17Z",
    fill: "url(#paint103_linear_13970_23982)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M272.175 45.4322C271.901 45.472 271.679 45.7284 271.679 46.0019C271.679 46.2754 271.901 46.4634 272.175 46.4235C272.449 46.3836 272.671 46.1272 272.671 45.8538C272.671 45.5803 272.449 45.3923 272.175 45.4322Z",
    fill: "url(#paint104_linear_13970_23982)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M270.532 45.6943C270.269 45.7341 270.053 45.9791 270.053 46.2412C270.053 46.5033 270.264 46.6856 270.532 46.6457C270.794 46.6059 271.011 46.3609 271.011 46.0988C271.011 45.8367 270.8 45.6544 270.532 45.6943Z",
    fill: "url(#paint105_linear_13970_23982)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M268.894 45.9506C268.643 45.9904 268.438 46.224 268.438 46.4747C268.438 46.7254 268.643 46.902 268.894 46.8678C269.145 46.828 269.351 46.5944 269.351 46.3437C269.351 46.093 269.145 45.9164 268.894 45.9506Z",
    fill: "url(#paint106_linear_13970_23982)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M267.257 46.2127C267.012 46.2469 266.818 46.4748 266.818 46.7198C266.818 46.9648 267.018 47.13 267.257 47.0958C267.503 47.0617 267.697 46.8338 267.697 46.5888C267.697 46.3438 267.497 46.1785 267.257 46.2127Z",
    fill: "url(#paint107_linear_13970_23982)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M265.619 46.4748C265.385 46.509 265.197 46.7255 265.197 46.9591C265.197 47.1927 265.385 47.3522 265.619 47.3181C265.853 47.2839 266.041 47.0674 266.041 46.8338C266.041 46.6002 265.853 46.4406 265.619 46.4748Z",
    fill: "url(#paint108_linear_13970_23982)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M263.977 46.7312C263.755 46.7654 263.572 46.9705 263.572 47.1927C263.572 47.4149 263.755 47.5688 263.977 47.5346C264.2 47.5004 264.382 47.2953 264.382 47.0731C264.382 46.8509 264.2 46.697 263.977 46.7312Z",
    fill: "url(#paint109_linear_13970_23982)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M262.339 46.9933C262.128 47.0275 261.951 47.2212 261.951 47.4377C261.951 47.6542 262.122 47.7967 262.339 47.7682C262.556 47.7397 262.727 47.5403 262.727 47.3238C262.727 47.1073 262.556 46.9648 262.339 46.9933Z",
    fill: "url(#paint110_linear_13970_23982)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M260.702 47.261C260.503 47.2895 260.337 47.4775 260.337 47.6769C260.337 47.8763 260.503 48.0187 260.702 47.9845C260.902 47.9561 261.068 47.768 261.068 47.5686C261.068 47.3692 260.902 47.2268 260.702 47.261Z",
    fill: "url(#paint111_linear_13970_23982)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M259.059 47.5173C258.871 47.5458 258.711 47.7225 258.711 47.9105C258.711 48.0985 258.865 48.2352 259.059 48.2067C259.248 48.1783 259.407 48.0016 259.407 47.8136C259.407 47.6256 259.253 47.4889 259.059 47.5173Z",
    fill: "url(#paint112_linear_13970_23982)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 47.7794C257.239 47.8079 257.097 47.9731 257.097 48.1555C257.097 48.3378 257.245 48.4631 257.422 48.4346C257.604 48.4062 257.747 48.2409 257.747 48.0586C257.747 47.8763 257.599 47.7509 257.422 47.7794Z",
    fill: "url(#paint113_linear_13970_23982)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M255.785 48.0416C255.614 48.0643 255.477 48.2239 255.477 48.3948C255.477 48.5657 255.614 48.6854 255.785 48.6569C255.956 48.6341 256.093 48.4746 256.093 48.3036C256.093 48.1327 255.956 48.0131 255.785 48.0416Z",
    fill: "url(#paint114_linear_13970_23982)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M254.148 48.2979C253.988 48.3207 253.857 48.4688 253.857 48.6341C253.857 48.7993 253.988 48.9075 254.148 48.8791C254.308 48.8563 254.439 48.7081 254.439 48.5429C254.439 48.3777 254.308 48.2694 254.148 48.2979Z",
    fill: "url(#paint115_linear_13970_23982)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M252.504 48.56C252.355 48.5828 252.23 48.7195 252.23 48.8734C252.23 49.0272 252.35 49.1298 252.504 49.107C252.652 49.0842 252.777 48.9474 252.777 48.7936C252.777 48.6398 252.658 48.5372 252.504 48.56Z",
    fill: "url(#paint116_linear_13970_23982)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M250.868 48.8222C250.725 48.845 250.611 48.976 250.611 49.1128C250.611 49.2495 250.725 49.3521 250.868 49.3293C251.01 49.3065 251.124 49.1755 251.124 49.0387C251.124 48.902 251.01 48.7994 250.868 48.8222Z",
    fill: "url(#paint117_linear_13970_23982)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 49.0785C249.099 49.0956 248.996 49.221 248.996 49.352C248.996 49.4831 249.105 49.5742 249.23 49.5514C249.356 49.5286 249.464 49.409 249.464 49.278C249.464 49.1469 249.356 49.0557 249.23 49.0785Z",
    fill: "url(#paint118_linear_13970_23982)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M247.586 49.3406C247.466 49.3577 247.369 49.4716 247.369 49.5913C247.369 49.7109 247.466 49.7964 247.586 49.7793C247.706 49.7622 247.803 49.6483 247.803 49.5286C247.803 49.409 247.706 49.3235 247.586 49.3406Z",
    fill: "url(#paint119_linear_13970_23982)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M245.949 49.6027C245.84 49.6197 245.749 49.7223 245.749 49.8306C245.749 49.9388 245.84 50.0186 245.949 50.0015C246.057 49.9844 246.148 49.8818 246.148 49.7736C246.148 49.6653 246.057 49.5856 245.949 49.6027Z",
    fill: "url(#paint120_linear_13970_23982)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M244.311 49.8591C244.208 49.8762 244.128 49.9673 244.128 50.0699C244.128 50.1725 244.208 50.2408 244.311 50.2237C244.413 50.2066 244.493 50.1155 244.493 50.0129C244.493 49.9104 244.413 49.842 244.311 49.8591Z",
    fill: "url(#paint121_linear_13970_23982)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M242.675 50.1211C242.584 50.1325 242.509 50.218 242.509 50.3091C242.509 50.4003 242.584 50.4629 242.675 50.4459C242.766 50.4288 242.84 50.349 242.84 50.2578C242.84 50.1667 242.766 50.104 242.675 50.1211Z",
    fill: "url(#paint122_linear_13970_23982)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M241.031 50.3832C240.951 50.3946 240.888 50.4687 240.888 50.5485C240.888 50.6282 240.951 50.6852 241.031 50.6738C241.111 50.6624 241.174 50.5883 241.174 50.5086C241.174 50.4288 241.111 50.3718 241.031 50.3832Z",
    fill: "url(#paint123_linear_13970_23982)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M239.393 50.6454C239.325 50.6568 239.268 50.7194 239.268 50.7878C239.268 50.8562 239.325 50.9017 239.393 50.8904C239.462 50.879 239.519 50.8163 239.519 50.7479C239.519 50.6795 239.462 50.634 239.393 50.6454Z",
    fill: "url(#paint124_linear_13970_23982)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M237.757 50.9076C237.699 50.9133 237.654 50.9703 237.654 51.0273C237.654 51.0843 237.699 51.1242 237.757 51.1185C237.814 51.1128 237.859 51.0558 237.859 50.9988C237.859 50.9418 237.814 50.9019 237.757 50.9076Z",
    fill: "url(#paint125_linear_13970_23982)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M236.119 51.1639C236.073 51.1696 236.033 51.2151 236.033 51.2607C236.033 51.3063 236.073 51.3405 236.119 51.3348C236.164 51.3291 236.204 51.2835 236.204 51.2379C236.204 51.1923 236.164 51.1582 236.119 51.1639Z",
    fill: "url(#paint126_linear_13970_23982)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 51.4259C234.437 51.4259 234.409 51.4658 234.409 51.5057C234.409 51.5456 234.437 51.5684 234.477 51.5627C234.517 51.5627 234.546 51.5228 234.546 51.4829C234.546 51.443 234.517 51.4202 234.477 51.4259Z",
    fill: "url(#paint127_linear_13970_23982)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M232.838 51.6881C232.838 51.6881 232.787 51.7166 232.787 51.745C232.787 51.7735 232.81 51.7906 232.838 51.7849C232.867 51.7849 232.89 51.7564 232.89 51.728C232.89 51.6995 232.867 51.6824 232.838 51.6881Z",
    fill: "url(#paint128_linear_13970_23982)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M231.201 51.9444C231.201 51.9444 231.166 51.9619 231.166 51.9793C231.166 51.9968 231.184 52.0085 231.201 52.0085C231.219 52.0085 231.236 51.991 231.236 51.9735C231.236 51.956 231.219 51.9444 231.201 51.9444Z",
    fill: "url(#paint129_linear_13970_23982)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M229.559 52.2066C229.559 52.2066 229.547 52.2125 229.547 52.2243C229.547 52.236 229.553 52.236 229.559 52.236C229.565 52.236 229.571 52.2302 229.571 52.2184C229.571 52.2066 229.565 52.2066 229.559 52.2066Z",
    fill: "url(#paint130_linear_13970_23982)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M298.394 39.6435C297.966 39.7061 297.618 40.105 297.618 40.5323C297.618 40.9596 297.966 41.2559 298.394 41.1932C298.822 41.1305 299.17 40.7317 299.17 40.3044C299.17 39.8771 298.822 39.5808 298.394 39.6435Z",
    fill: "url(#paint131_linear_13970_23982)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M296.757 39.8828C296.329 39.9455 295.981 40.3443 295.981 40.7717C295.981 41.199 296.329 41.4952 296.757 41.4326C297.185 41.3699 297.533 40.9711 297.533 40.5438C297.533 40.1164 297.185 39.8202 296.757 39.8828Z",
    fill: "url(#paint132_linear_13970_23982)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M295.121 40.1449C294.704 40.2076 294.362 40.595 294.362 41.0166C294.362 41.4383 294.704 41.7231 295.121 41.6605C295.537 41.5978 295.88 41.2104 295.88 40.7887C295.88 40.3671 295.537 40.0823 295.121 40.1449Z",
    fill: "url(#paint133_linear_13970_23982)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M293.477 40.4069C293.066 40.4696 292.735 40.8456 292.735 41.2558C292.735 41.666 293.066 41.9452 293.477 41.8882C293.887 41.8256 294.218 41.4495 294.218 41.0393C294.218 40.6291 293.887 40.3499 293.477 40.4069Z",
    fill: "url(#paint134_linear_13970_23982)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M291.84 40.6631C291.44 40.7201 291.115 41.0905 291.115 41.4893C291.115 41.8881 291.44 42.1616 291.84 42.1046C292.239 42.0476 292.564 41.6773 292.564 41.2785C292.564 40.8796 292.239 40.6062 291.84 40.6631Z",
    fill: "url(#paint135_linear_13970_23982)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M290.202 40.9254C289.814 40.9823 289.5 41.347 289.5 41.7344C289.5 42.1218 289.814 42.3896 290.202 42.3326C290.59 42.2757 290.904 41.911 290.904 41.5236C290.904 41.1362 290.59 40.8684 290.202 40.9254Z",
    fill: "url(#paint136_linear_13970_23982)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M288.558 41.1874C288.182 41.2444 287.88 41.592 287.88 41.968C287.88 42.344 288.182 42.6061 288.558 42.5491C288.935 42.4922 289.237 42.1446 289.237 41.7686C289.237 41.3925 288.935 41.1305 288.558 41.1874Z",
    fill: "url(#paint137_linear_13970_23982)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M286.923 41.4497C286.558 41.5009 286.262 41.8428 286.262 42.2131C286.262 42.5835 286.558 42.8341 286.923 42.7772C287.289 42.7202 287.585 42.384 287.585 42.0137C287.585 41.6434 287.289 41.3927 286.923 41.4497Z",
    fill: "url(#paint138_linear_13970_23982)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M285.284 41.7118C284.931 41.7631 284.64 42.0935 284.64 42.4525C284.64 42.8114 284.931 43.0564 285.284 42.9994C285.638 42.9481 285.929 42.6177 285.929 42.2587C285.929 41.8998 285.638 41.6548 285.284 41.7118Z",
    fill: "url(#paint139_linear_13970_23982)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M283.647 41.968C283.299 42.0193 283.02 42.3383 283.02 42.6859C283.02 43.0334 283.299 43.2727 283.647 43.2215C283.995 43.1702 284.275 42.8511 284.275 42.5036C284.275 42.156 283.995 41.9167 283.647 41.968Z",
    fill: "url(#paint140_linear_13970_23982)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M282.004 42.2302C281.668 42.2815 281.394 42.5949 281.394 42.931C281.394 43.2672 281.668 43.5008 282.004 43.4495C282.341 43.3982 282.615 43.0849 282.615 42.7487C282.615 42.4126 282.341 42.179 282.004 42.2302Z",
    fill: "url(#paint141_linear_13970_23982)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M280.367 42.4923C280.042 42.5379 279.774 42.8456 279.774 43.1703C279.774 43.4951 280.036 43.723 280.367 43.6717C280.692 43.6261 280.961 43.3185 280.961 42.9937C280.961 42.6689 280.698 42.441 280.367 42.4923Z",
    fill: "url(#paint142_linear_13970_23982)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M278.731 42.7486C278.417 42.7942 278.16 43.0905 278.16 43.4038C278.16 43.7172 278.417 43.9394 278.731 43.8938C279.045 43.8482 279.301 43.552 279.301 43.2386C279.301 42.9252 279.045 42.703 278.731 42.7486Z",
    fill: "url(#paint143_linear_13970_23982)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M277.092 43.0108C276.784 43.0564 276.538 43.3413 276.538 43.6489C276.538 43.9566 276.789 44.1674 277.092 44.1218C277.4 44.0762 277.645 43.7914 277.645 43.4837C277.645 43.176 277.394 42.9652 277.092 43.0108Z",
    fill: "url(#paint144_linear_13970_23982)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M275.449 43.2784C275.158 43.324 274.918 43.5975 274.918 43.8881C274.918 44.1786 275.158 44.3838 275.449 44.3382C275.74 44.2926 275.98 44.0191 275.98 43.7285C275.98 43.438 275.74 43.2329 275.449 43.2784Z",
    fill: "url(#paint145_linear_13970_23982)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M273.813 43.535C273.528 43.5749 273.3 43.8427 273.3 44.1218C273.3 44.401 273.528 44.6004 273.813 44.5605C274.098 44.5207 274.326 44.2529 274.326 43.9737C274.326 43.6945 274.098 43.4951 273.813 43.535Z",
    fill: "url(#paint146_linear_13970_23982)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M272.175 43.7969C271.901 43.8368 271.679 44.0932 271.679 44.3667C271.679 44.6402 271.901 44.8282 272.175 44.7883C272.449 44.7484 272.671 44.492 272.671 44.2185C272.671 43.9451 272.449 43.757 272.175 43.7969Z",
    fill: "url(#paint147_linear_13970_23982)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M270.532 44.059C270.269 44.0989 270.053 44.3439 270.053 44.606C270.053 44.868 270.264 45.0504 270.532 45.0105C270.794 44.9706 271.011 44.7256 271.011 44.4635C271.011 44.2014 270.8 44.0191 270.532 44.059Z",
    fill: "url(#paint148_linear_13970_23982)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M268.894 44.3155C268.643 44.3553 268.438 44.5889 268.438 44.8396C268.438 45.0903 268.643 45.2669 268.894 45.2327C269.145 45.1929 269.351 44.9593 269.351 44.7086C269.351 44.4579 269.145 44.2813 268.894 44.3155Z",
    fill: "url(#paint149_linear_13970_23982)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M267.257 44.5776C267.012 44.6118 266.818 44.8397 266.818 45.0847C266.818 45.3297 267.018 45.4949 267.257 45.4607C267.503 45.4266 267.697 45.1987 267.697 44.9537C267.697 44.7087 267.497 44.5434 267.257 44.5776Z",
    fill: "url(#paint150_linear_13970_23982)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M265.619 44.8396C265.385 44.8738 265.197 45.0903 265.197 45.3239C265.197 45.5575 265.385 45.717 265.619 45.6828C265.853 45.6486 266.041 45.4321 266.041 45.1985C266.041 44.9649 265.853 44.8054 265.619 44.8396Z",
    fill: "url(#paint151_linear_13970_23982)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M263.977 45.096C263.755 45.1302 263.572 45.3353 263.572 45.5575C263.572 45.7797 263.755 45.9335 263.977 45.8993C264.2 45.8652 264.382 45.6601 264.382 45.4379C264.382 45.2157 264.2 45.0618 263.977 45.096Z",
    fill: "url(#paint152_linear_13970_23982)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M262.339 45.3581C262.128 45.3923 261.951 45.586 261.951 45.8025C261.951 46.019 262.122 46.1614 262.339 46.1329C262.556 46.1045 262.727 45.905 262.727 45.6885C262.727 45.472 262.556 45.3296 262.339 45.3581Z",
    fill: "url(#paint153_linear_13970_23982)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M260.702 45.6201C260.503 45.6486 260.337 45.8366 260.337 46.036C260.337 46.2354 260.503 46.3778 260.702 46.3436C260.902 46.3152 261.068 46.1271 261.068 45.9277C261.068 45.7283 260.902 45.5859 260.702 45.6201Z",
    fill: "url(#paint154_linear_13970_23982)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M259.059 45.8822C258.871 45.9107 258.711 46.0873 258.711 46.2754C258.711 46.4634 258.865 46.6001 259.059 46.5716C259.248 46.5431 259.407 46.3665 259.407 46.1785C259.407 45.9905 259.253 45.8538 259.059 45.8822Z",
    fill: "url(#paint155_linear_13970_23982)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 46.1445C257.239 46.173 257.097 46.3382 257.097 46.5205C257.097 46.7028 257.245 46.8282 257.422 46.7997C257.604 46.7712 257.747 46.606 257.747 46.4237C257.747 46.2413 257.599 46.116 257.422 46.1445Z",
    fill: "url(#paint156_linear_13970_23982)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M255.785 46.4008C255.614 46.4236 255.477 46.5831 255.477 46.754C255.477 46.9249 255.614 47.0446 255.785 47.0161C255.956 46.9933 256.093 46.8338 256.093 46.6629C256.093 46.4919 255.956 46.3723 255.785 46.4008Z",
    fill: "url(#paint157_linear_13970_23982)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M254.148 46.6629C253.988 46.6857 253.857 46.8339 253.857 46.9991C253.857 47.1643 253.988 47.2726 254.148 47.2441C254.308 47.2213 254.439 47.0732 254.439 46.9079C254.439 46.7427 254.308 46.6344 254.148 46.6629Z",
    fill: "url(#paint158_linear_13970_23982)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M252.504 46.9249C252.355 46.9477 252.23 47.0844 252.23 47.2383C252.23 47.3921 252.35 47.4947 252.504 47.4719C252.652 47.4491 252.777 47.3123 252.777 47.1585C252.777 47.0047 252.658 46.9021 252.504 46.9249Z",
    fill: "url(#paint159_linear_13970_23982)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M250.868 47.1813C250.725 47.2041 250.611 47.3351 250.611 47.4719C250.611 47.6086 250.725 47.7112 250.868 47.6884C251.01 47.6656 251.124 47.5346 251.124 47.3978C251.124 47.2611 251.01 47.1585 250.868 47.1813Z",
    fill: "url(#paint160_linear_13970_23982)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 47.4434C249.099 47.4605 248.996 47.5859 248.996 47.7169C248.996 47.848 249.105 47.9391 249.23 47.9163C249.356 47.8935 249.464 47.7739 249.464 47.6429C249.464 47.5118 249.356 47.4206 249.23 47.4434Z",
    fill: "url(#paint161_linear_13970_23982)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M247.586 47.7055C247.466 47.7226 247.369 47.8365 247.369 47.9562C247.369 48.0758 247.466 48.1613 247.586 48.1442C247.706 48.1271 247.803 48.0132 247.803 47.8935C247.803 47.7739 247.706 47.6884 247.586 47.7055Z",
    fill: "url(#paint162_linear_13970_23982)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M245.949 47.9618C245.84 47.9788 245.749 48.0814 245.749 48.1897C245.749 48.2979 245.84 48.3777 245.949 48.3606C246.057 48.3435 246.148 48.2409 246.148 48.1327C246.148 48.0244 246.057 47.9447 245.949 47.9618Z",
    fill: "url(#paint163_linear_13970_23982)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M244.311 48.224C244.208 48.2411 244.128 48.3322 244.128 48.4348C244.128 48.5374 244.208 48.6057 244.311 48.5886C244.413 48.5715 244.493 48.4804 244.493 48.3778C244.493 48.2753 244.413 48.2069 244.311 48.224Z",
    fill: "url(#paint164_linear_13970_23982)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M242.675 48.4862C242.584 48.4975 242.509 48.583 242.509 48.6742C242.509 48.7653 242.584 48.828 242.675 48.8109C242.766 48.7938 242.84 48.7141 242.84 48.6229C242.84 48.5317 242.766 48.4691 242.675 48.4862Z",
    fill: "url(#paint165_linear_13970_23982)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M241.031 48.7423C240.951 48.7537 240.888 48.8278 240.888 48.9076C240.888 48.9873 240.951 49.0443 241.031 49.0329C241.111 49.0215 241.174 48.9474 241.174 48.8677C241.174 48.7879 241.111 48.7309 241.031 48.7423Z",
    fill: "url(#paint166_linear_13970_23982)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M239.393 49.0103C239.325 49.0217 239.268 49.0843 239.268 49.1527C239.268 49.2211 239.325 49.2666 239.393 49.2553C239.462 49.2439 239.519 49.1812 239.519 49.1128C239.519 49.0444 239.462 48.9989 239.393 49.0103Z",
    fill: "url(#paint167_linear_13970_23982)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M237.757 49.2666C237.699 49.278 237.654 49.3293 237.654 49.3862C237.654 49.4432 237.699 49.4831 237.757 49.4774C237.814 49.4717 237.859 49.4147 237.859 49.3578C237.859 49.3008 237.814 49.2609 237.757 49.2666Z",
    fill: "url(#paint168_linear_13970_23982)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M236.119 49.5286C236.073 49.5343 236.033 49.5799 236.033 49.6255C236.033 49.671 236.073 49.7052 236.119 49.6995C236.164 49.6938 236.204 49.6483 236.204 49.6027C236.204 49.5571 236.164 49.5229 236.119 49.5286Z",
    fill: "url(#paint169_linear_13970_23982)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 49.7908C234.437 49.7908 234.409 49.8307 234.409 49.8706C234.409 49.9105 234.437 49.9333 234.477 49.9276C234.517 49.9219 234.546 49.8877 234.546 49.8478C234.546 49.8079 234.517 49.7851 234.477 49.7908Z",
    fill: "url(#paint170_linear_13970_23982)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M232.838 50.0472C232.838 50.0472 232.787 50.0757 232.787 50.1041C232.787 50.1326 232.81 50.1497 232.838 50.144C232.867 50.144 232.89 50.1155 232.89 50.0871C232.89 50.0586 232.867 50.0415 232.838 50.0472Z",
    fill: "url(#paint171_linear_13970_23982)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M231.201 50.3092C231.201 50.3092 231.166 50.3266 231.166 50.3441C231.166 50.3616 231.184 50.3732 231.201 50.3732C231.219 50.3732 231.236 50.3558 231.236 50.3383C231.236 50.3208 231.219 50.3092 231.201 50.3092Z",
    fill: "url(#paint172_linear_13970_23982)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M229.559 50.5713C229.559 50.5713 229.547 50.5771 229.547 50.5889C229.547 50.6007 229.553 50.6007 229.559 50.6007C229.565 50.6007 229.571 50.5948 229.571 50.583C229.571 50.5713 229.565 50.5713 229.559 50.5713Z",
    fill: "url(#paint173_linear_13970_23982)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M298.394 38.0084C297.966 38.071 297.618 38.4699 297.618 38.8972C297.618 39.3245 297.966 39.6208 298.394 39.5581C298.822 39.4954 299.17 39.0966 299.17 38.6693C299.17 38.242 298.822 37.9457 298.394 38.0084Z",
    fill: "url(#paint174_linear_13970_23982)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M296.757 38.2476C296.329 38.3103 295.981 38.7091 295.981 39.1364C295.981 39.5637 296.329 39.86 296.757 39.7973C297.185 39.7346 297.533 39.3358 297.533 38.9085C297.533 38.4812 297.185 38.1849 296.757 38.2476Z",
    fill: "url(#paint175_linear_13970_23982)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M295.121 38.5097C294.704 38.5723 294.362 38.9598 294.362 39.3814C294.362 39.803 294.704 40.0879 295.121 40.0252C295.537 39.9625 295.88 39.5751 295.88 39.1535C295.88 38.7319 295.537 38.447 295.121 38.5097Z",
    fill: "url(#paint176_linear_13970_23982)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M293.477 38.7661C293.066 38.8288 292.735 39.2048 292.735 39.615C292.735 40.0252 293.066 40.3044 293.477 40.2474C293.887 40.1848 294.218 39.8087 294.218 39.3985C294.218 38.9883 293.887 38.7091 293.477 38.7661Z",
    fill: "url(#paint177_linear_13970_23982)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M291.84 39.0282C291.44 39.0851 291.115 39.4555 291.115 39.8543C291.115 40.2531 291.44 40.5266 291.84 40.4696C292.239 40.4127 292.564 40.0423 292.564 39.6435C292.564 39.2447 292.239 38.9712 291.84 39.0282Z",
    fill: "url(#paint178_linear_13970_23982)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M290.202 39.2903C289.814 39.3472 289.5 39.7119 289.5 40.0993C289.5 40.4867 289.814 40.7545 290.202 40.6975C290.59 40.6406 290.904 40.2759 290.904 39.8885C290.904 39.5011 290.59 39.2333 290.202 39.2903Z",
    fill: "url(#paint179_linear_13970_23982)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M288.558 39.5523C288.182 39.6093 287.88 39.9569 287.88 40.3329C287.88 40.7089 288.182 40.971 288.558 40.914C288.935 40.8571 289.237 40.5095 289.237 40.1335C289.237 39.7574 288.935 39.4954 288.558 39.5523Z",
    fill: "url(#paint180_linear_13970_23982)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M286.923 39.8143C286.558 39.8656 286.262 40.2075 286.262 40.5721C286.262 40.9367 286.558 41.1931 286.923 41.1362C287.289 41.0792 287.585 40.743 287.585 40.3727C287.585 40.0024 287.289 39.7517 286.923 39.8086V39.8143Z",
    fill: "url(#paint181_linear_13970_23982)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M285.284 40.0708C284.931 40.1221 284.64 40.4526 284.64 40.8115C284.64 41.1705 284.931 41.4155 285.284 41.3585C285.638 41.3072 285.929 40.9768 285.929 40.6178C285.929 40.2589 285.638 40.0139 285.284 40.0708Z",
    fill: "url(#paint182_linear_13970_23982)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M283.647 40.3329C283.299 40.3842 283.02 40.7032 283.02 41.0508C283.02 41.3983 283.299 41.6376 283.647 41.5864C283.995 41.5351 284.275 41.216 284.275 40.8685C284.275 40.5209 283.995 40.2816 283.647 40.3329Z",
    fill: "url(#paint183_linear_13970_23982)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M282.004 40.595C281.668 40.6463 281.394 40.9597 281.394 41.2958C281.394 41.632 281.668 41.8656 282.004 41.8143C282.341 41.763 282.615 41.4496 282.615 41.1135C282.615 40.7773 282.341 40.5437 282.004 40.595Z",
    fill: "url(#paint184_linear_13970_23982)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M280.367 40.8514C280.042 40.897 279.774 41.2047 279.774 41.5294C279.774 41.8542 280.036 42.0821 280.367 42.0308C280.692 41.9852 280.961 41.6776 280.961 41.3528C280.961 41.028 280.698 40.8001 280.367 40.8514Z",
    fill: "url(#paint185_linear_13970_23982)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M278.731 41.1135C278.417 41.1591 278.16 41.4554 278.16 41.7687C278.16 42.0821 278.417 42.3043 278.731 42.2587C279.045 42.2131 279.301 41.9169 279.301 41.6035C279.301 41.2901 279.045 41.0679 278.731 41.1135Z",
    fill: "url(#paint186_linear_13970_23982)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M277.092 41.3756C276.784 41.4212 276.538 41.706 276.538 42.0137C276.538 42.3214 276.789 42.5322 277.092 42.4866C277.4 42.441 277.645 42.1561 277.645 41.8485C277.645 41.5408 277.394 41.33 277.092 41.3756Z",
    fill: "url(#paint187_linear_13970_23982)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M275.449 41.6377C275.158 41.6832 274.918 41.9567 274.918 42.2473C274.918 42.5379 275.158 42.743 275.449 42.6974C275.74 42.6518 275.98 42.3783 275.98 42.0878C275.98 41.7972 275.74 41.5921 275.449 41.6377Z",
    fill: "url(#paint188_linear_13970_23982)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M273.813 41.8996C273.528 41.9395 273.3 42.2073 273.3 42.4865C273.3 42.7657 273.528 42.9651 273.813 42.9252C274.098 42.8853 274.326 42.6175 274.326 42.3384C274.326 42.0592 274.098 41.8598 273.813 41.8996Z",
    fill: "url(#paint189_linear_13970_23982)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M272.175 42.1618C271.901 42.2017 271.679 42.4581 271.679 42.7316C271.679 43.0051 271.901 43.1931 272.175 43.1532C272.449 43.1133 272.671 42.8569 272.671 42.5834C272.671 42.31 272.449 42.1219 272.175 42.1618Z",
    fill: "url(#paint190_linear_13970_23982)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M270.532 42.4182C270.269 42.4581 270.053 42.7031 270.053 42.9652C270.053 43.2273 270.264 43.4096 270.532 43.3697C270.794 43.3298 271.011 43.0848 271.011 42.8227C271.011 42.5607 270.8 42.3783 270.532 42.4182Z",
    fill: "url(#paint191_linear_13970_23982)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M268.894 42.6804C268.643 42.7202 268.438 42.9538 268.438 43.2045C268.438 43.4552 268.643 43.6318 268.894 43.5976C269.145 43.5578 269.351 43.3242 269.351 43.0735C269.351 42.8228 269.145 42.6462 268.894 42.6804Z",
    fill: "url(#paint192_linear_13970_23982)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M267.257 42.9424C267.012 42.9766 266.818 43.2045 266.818 43.4495C266.818 43.6945 267.018 43.8597 267.257 43.8255C267.503 43.7913 267.697 43.5634 267.697 43.3184C267.697 43.0734 267.497 42.9082 267.257 42.9424Z",
    fill: "url(#paint193_linear_13970_23982)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M265.619 43.1987C265.385 43.2329 265.197 43.4494 265.197 43.683C265.197 43.9166 265.385 44.0761 265.619 44.0419C265.853 44.0077 266.041 43.7912 266.041 43.5576C266.041 43.324 265.853 43.1645 265.619 43.1987Z",
    fill: "url(#paint194_linear_13970_23982)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M263.977 43.4608C263.755 43.495 263.572 43.7001 263.572 43.9223C263.572 44.1445 263.755 44.2983 263.977 44.2641C264.2 44.2299 264.382 44.0248 264.382 43.8026C264.382 43.5804 264.2 43.4266 263.977 43.4608Z",
    fill: "url(#paint195_linear_13970_23982)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M262.339 43.723C262.128 43.7572 261.951 43.9509 261.951 44.1674C261.951 44.3839 262.122 44.5263 262.339 44.4978C262.55 44.4637 262.727 44.2699 262.727 44.0534C262.727 43.8369 262.556 43.6945 262.339 43.723Z",
    fill: "url(#paint196_linear_13970_23982)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M260.702 43.9851C260.503 44.0136 260.337 44.2016 260.337 44.401C260.337 44.6004 260.503 44.7429 260.702 44.7087C260.902 44.6802 261.068 44.4922 261.068 44.2928C261.068 44.0933 260.902 43.9509 260.702 43.9851Z",
    fill: "url(#paint197_linear_13970_23982)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M259.059 44.247C258.871 44.2755 258.711 44.4521 258.711 44.6401C258.711 44.8282 258.865 44.9649 259.059 44.9364C259.248 44.9079 259.407 44.7313 259.407 44.5433C259.407 44.3553 259.253 44.2185 259.059 44.247Z",
    fill: "url(#paint198_linear_13970_23982)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 44.5035C257.239 44.532 257.097 44.6973 257.097 44.8796C257.097 45.0619 257.245 45.1872 257.422 45.1588C257.604 45.1303 257.747 44.965 257.747 44.7827C257.747 44.6004 257.599 44.4751 257.422 44.5035Z",
    fill: "url(#paint199_linear_13970_23982)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M255.785 44.7655C255.614 44.7883 255.477 44.9478 255.477 45.1188C255.477 45.2897 255.614 45.4093 255.785 45.3809C255.956 45.3581 256.093 45.1985 256.093 45.0276C256.093 44.8567 255.956 44.737 255.785 44.7655Z",
    fill: "url(#paint200_linear_13970_23982)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M254.148 45.0276C253.988 45.0503 253.857 45.1985 253.857 45.3637C253.857 45.5289 253.988 45.6372 254.148 45.6087C254.308 45.5859 254.439 45.4378 254.439 45.2725C254.439 45.1073 254.308 44.9991 254.148 45.0276Z",
    fill: "url(#paint201_linear_13970_23982)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M252.504 45.284C252.355 45.3068 252.23 45.4435 252.23 45.5974C252.23 45.7512 252.35 45.8537 252.504 45.8309C252.652 45.8082 252.777 45.6714 252.777 45.5176C252.777 45.3638 252.658 45.2612 252.504 45.284Z",
    fill: "url(#paint202_linear_13970_23982)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M250.868 45.5461C250.725 45.5689 250.611 45.6999 250.611 45.8367C250.611 45.9734 250.725 46.076 250.868 46.0532C251.01 46.0304 251.124 45.8993 251.124 45.7626C251.124 45.6259 251.01 45.5233 250.868 45.5461Z",
    fill: "url(#paint203_linear_13970_23982)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 45.8081C249.099 45.8252 248.996 45.9505 248.996 46.0816C248.996 46.2126 249.105 46.3038 249.23 46.281C249.356 46.2582 249.464 46.1385 249.464 46.0075C249.464 45.8765 249.356 45.7853 249.23 45.8081Z",
    fill: "url(#paint204_linear_13970_23982)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M247.586 46.0646C247.466 46.0817 247.369 46.1956 247.369 46.3153C247.369 46.4349 247.466 46.5204 247.586 46.5033C247.706 46.4862 247.803 46.3723 247.803 46.2526C247.803 46.133 247.706 46.0475 247.586 46.0646Z",
    fill: "url(#paint205_linear_13970_23982)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M245.949 46.3267C245.84 46.3437 245.749 46.4463 245.749 46.5546C245.749 46.6628 245.84 46.7426 245.949 46.7255C246.057 46.7084 246.148 46.6058 246.148 46.4976C246.148 46.3893 246.057 46.3096 245.949 46.3267Z",
    fill: "url(#paint206_linear_13970_23982)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M244.311 46.5888C244.208 46.6059 244.128 46.697 244.128 46.7996C244.128 46.9021 244.208 46.9705 244.311 46.9534C244.413 46.9363 244.493 46.8452 244.493 46.7426C244.493 46.64 244.413 46.5717 244.311 46.5888Z",
    fill: "url(#paint207_linear_13970_23982)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M242.675 46.8452C242.584 46.8566 242.509 46.9421 242.509 47.0332C242.509 47.1244 242.584 47.1871 242.675 47.17C242.766 47.1529 242.84 47.0731 242.84 46.982C242.84 46.8908 242.766 46.8281 242.675 46.8452Z",
    fill: "url(#paint208_linear_13970_23982)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M241.031 47.1072C240.951 47.1186 240.888 47.1927 240.888 47.2725C240.888 47.3522 240.951 47.4092 241.031 47.3978C241.111 47.3864 241.174 47.3123 241.174 47.2326C241.174 47.1528 241.111 47.0958 241.031 47.1072Z",
    fill: "url(#paint209_linear_13970_23982)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M239.393 47.3692C239.325 47.3806 239.268 47.4433 239.268 47.5116C239.268 47.58 239.325 47.6256 239.393 47.6142C239.462 47.6028 239.519 47.5401 239.519 47.4718C239.519 47.4034 239.462 47.3578 239.393 47.3692Z",
    fill: "url(#paint210_linear_13970_23982)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M237.757 47.6314C237.699 47.6371 237.654 47.694 237.654 47.751C237.654 47.808 237.699 47.8479 237.757 47.8422C237.814 47.8365 237.859 47.7795 237.859 47.7225C237.859 47.6656 237.814 47.6257 237.757 47.6314Z",
    fill: "url(#paint211_linear_13970_23982)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M236.119 47.8935C236.073 47.8992 236.033 47.9448 236.033 47.9904C236.033 48.0359 236.073 48.0701 236.119 48.0644C236.164 48.0587 236.204 48.0132 236.204 47.9676C236.204 47.922 236.164 47.8878 236.119 47.8935Z",
    fill: "url(#paint212_linear_13970_23982)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M234.477 48.1498C234.437 48.1498 234.409 48.1896 234.409 48.2295C234.409 48.2694 234.437 48.2922 234.477 48.2865C234.517 48.2808 234.546 48.2466 234.546 48.2067C234.546 48.1669 234.517 48.1441 234.477 48.1498Z",
    fill: "url(#paint213_linear_13970_23982)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M232.838 48.4119C232.838 48.4119 232.787 48.4404 232.787 48.4689C232.787 48.4974 232.81 48.5145 232.838 48.5088C232.867 48.5088 232.89 48.4803 232.89 48.4518C232.89 48.4233 232.867 48.4063 232.838 48.4119Z",
    fill: "url(#paint214_linear_13970_23982)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M231.201 48.674C231.201 48.674 231.166 48.6914 231.166 48.7089C231.166 48.7264 231.184 48.738 231.201 48.738C231.219 48.738 231.236 48.7205 231.236 48.7031C231.236 48.6856 231.219 48.674 231.201 48.674Z",
    fill: "url(#paint215_linear_13970_23982)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M229.559 48.9303C229.559 48.9303 229.547 48.9362 229.547 48.948C229.547 48.9598 229.553 48.9598 229.559 48.9598C229.565 48.9598 229.571 48.9539 229.571 48.9421C229.571 48.9303 229.565 48.9303 229.559 48.9303Z",
    fill: "url(#paint216_linear_13970_23982)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13970_23982",
    x: 0,
    y: 0,
    width: 372,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.455321 0 0 0 0 0.321042 0 0 0 0 0.8375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13970_23982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13970_23982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13970_23982",
    x: 0,
    y: 0,
    width: 209,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.455321 0 0 0 0 0.321042 0 0 0 0 0.8375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13970_23982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13970_23982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13970_23982",
    x1: 18,
    y1: 96.069,
    x2: 191,
    y2: 96.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13970_23982",
    x1: 198,
    y1: 77.4446,
    x2: 299.429,
    y2: 77.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13970_23982",
    x1: 297.618,
    y1: 45.4917,
    x2: 299.17,
    y2: 45.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13970_23982",
    x1: 295.981,
    y1: 45.731,
    x2: 297.533,
    y2: 45.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13970_23982",
    x1: 294.362,
    y1: 45.9724,
    x2: 295.88,
    y2: 45.9724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13970_23982",
    x1: 292.735,
    y1: 46.2079,
    x2: 294.218,
    y2: 46.2079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13970_23982",
    x1: 291.115,
    y1: 46.4459,
    x2: 292.564,
    y2: 46.4459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13970_23982",
    x1: 289.5,
    y1: 46.6874,
    x2: 290.904,
    y2: 46.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13970_23982",
    x1: 287.88,
    y1: 46.922,
    x2: 289.237,
    y2: 46.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13970_23982",
    x1: 286.262,
    y1: 47.1637,
    x2: 287.585,
    y2: 47.1637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13970_23982",
    x1: 284.64,
    y1: 47.4017,
    x2: 285.929,
    y2: 47.4017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13970_23982",
    x1: 283.02,
    y1: 47.6371,
    x2: 284.275,
    y2: 47.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13970_23982",
    x1: 281.394,
    y1: 47.8786,
    x2: 282.615,
    y2: 47.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_13970_23982",
    x1: 279.774,
    y1: 48.1166,
    x2: 280.961,
    y2: 48.1166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13970_23982",
    x1: 278.16,
    y1: 48.3521,
    x2: 279.301,
    y2: 48.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_13970_23982",
    x1: 276.538,
    y1: 48.5938,
    x2: 277.645,
    y2: 48.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_13970_23982",
    x1: 274.918,
    y1: 48.8249,
    x2: 275.98,
    y2: 48.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_13970_23982",
    x1: 273.3,
    y1: 49.066,
    x2: 274.326,
    y2: 49.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_13970_23982",
    x1: 271.679,
    y1: 49.3075,
    x2: 272.671,
    y2: 49.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_13970_23982",
    x1: 270.053,
    y1: 49.5399,
    x2: 271.011,
    y2: 49.5399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_13970_23982",
    x1: 268.438,
    y1: 49.7811,
    x2: 269.351,
    y2: 49.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_13970_23982",
    x1: 266.818,
    y1: 50.0226,
    x2: 267.697,
    y2: 50.0226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_13970_23982",
    x1: 265.197,
    y1: 50.2549,
    x2: 266.041,
    y2: 50.2549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_13970_23982",
    x1: 263.572,
    y1: 50.493,
    x2: 264.382,
    y2: 50.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_13970_23982",
    x1: 261.951,
    y1: 50.7377,
    x2: 262.727,
    y2: 50.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_13970_23982",
    x1: 260.337,
    y1: 50.969,
    x2: 261.068,
    y2: 50.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_13970_23982",
    x1: 258.711,
    y1: 51.2102,
    x2: 259.407,
    y2: 51.2102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_13970_23982",
    x1: 257.097,
    y1: 51.4461,
    x2: 257.747,
    y2: 51.4461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_13970_23982",
    x1: 255.477,
    y1: 51.6841,
    x2: 256.093,
    y2: 51.6841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_13970_23982",
    x1: 253.857,
    y1: 51.9257,
    x2: 254.439,
    y2: 51.9257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_13970_23982",
    x1: 252.23,
    y1: 52.1612,
    x2: 252.777,
    y2: 52.1612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_13970_23982",
    x1: 250.611,
    y1: 52.3992,
    x2: 251.124,
    y2: 52.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_13970_23982",
    x1: 248.996,
    y1: 52.6408,
    x2: 249.464,
    y2: 52.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_13970_23982",
    x1: 247.369,
    y1: 52.8761,
    x2: 247.803,
    y2: 52.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_13970_23982",
    x1: 245.749,
    y1: 53.1143,
    x2: 246.148,
    y2: 53.1143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_13970_23982",
    x1: 244.128,
    y1: 53.3557,
    x2: 244.493,
    y2: 53.3557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_13970_23982",
    x1: 242.509,
    y1: 53.588,
    x2: 242.84,
    y2: 53.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_13970_23982",
    x1: 240.888,
    y1: 53.8292,
    x2: 241.174,
    y2: 53.8292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_13970_23982",
    x1: 239.268,
    y1: 54.0696,
    x2: 239.519,
    y2: 54.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_13970_23982",
    x1: 237.654,
    y1: 54.3052,
    x2: 237.859,
    y2: 54.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_13970_23982",
    x1: 236.033,
    y1: 54.5431,
    x2: 236.204,
    y2: 54.5431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_13970_23982",
    x1: 234.409,
    y1: 54.7847,
    x2: 234.546,
    y2: 54.7847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_13970_23982",
    x1: 232.787,
    y1: 55.0171,
    x2: 232.89,
    y2: 55.0171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_13970_23982",
    x1: 231.166,
    y1: 55.2591,
    x2: 231.236,
    y2: 55.2591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_13970_23982",
    x1: 229.547,
    y1: 55.5003,
    x2: 229.571,
    y2: 55.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_13970_23982",
    x1: 297.618,
    y1: 43.8508,
    x2: 299.17,
    y2: 43.8508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_13970_23982",
    x1: 295.981,
    y1: 44.0958,
    x2: 297.533,
    y2: 44.0958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_13970_23982",
    x1: 294.362,
    y1: 44.3316,
    x2: 295.88,
    y2: 44.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_13970_23982",
    x1: 292.735,
    y1: 44.5727,
    x2: 294.218,
    y2: 44.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_13970_23982",
    x1: 291.115,
    y1: 44.8108,
    x2: 292.564,
    y2: 44.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_13970_23982",
    x1: 289.5,
    y1: 45.0465,
    x2: 290.904,
    y2: 45.0465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_13970_23982",
    x1: 287.88,
    y1: 45.2869,
    x2: 289.237,
    y2: 45.2869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_13970_23982",
    x1: 286.262,
    y1: 45.5283,
    x2: 287.585,
    y2: 45.5283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_13970_23982",
    x1: 284.64,
    y1: 45.7608,
    x2: 285.929,
    y2: 45.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_13970_23982",
    x1: 283.02,
    y1: 46.0019,
    x2: 284.275,
    y2: 46.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_13970_23982",
    x1: 281.394,
    y1: 46.2435,
    x2: 282.615,
    y2: 46.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_13970_23982",
    x1: 279.774,
    y1: 46.4757,
    x2: 280.961,
    y2: 46.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_13970_23982",
    x1: 278.16,
    y1: 46.717,
    x2: 279.301,
    y2: 46.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_13970_23982",
    x1: 276.538,
    y1: 46.9585,
    x2: 277.645,
    y2: 46.9585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_13970_23982",
    x1: 274.918,
    y1: 47.1896,
    x2: 275.98,
    y2: 47.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_13970_23982",
    x1: 273.3,
    y1: 47.4309,
    x2: 274.326,
    y2: 47.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_13970_23982",
    x1: 271.679,
    y1: 47.6667,
    x2: 272.671,
    y2: 47.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_13970_23982",
    x1: 270.053,
    y1: 47.9048,
    x2: 271.011,
    y2: 47.9048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_13970_23982",
    x1: 268.438,
    y1: 48.1459,
    x2: 269.351,
    y2: 48.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_13970_23982",
    x1: 266.818,
    y1: 48.3817,
    x2: 267.697,
    y2: 48.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_13970_23982",
    x1: 265.197,
    y1: 48.6198,
    x2: 266.041,
    y2: 48.6198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_13970_23982",
    x1: 263.572,
    y1: 48.8579,
    x2: 264.382,
    y2: 48.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_13970_23982",
    x1: 261.951,
    y1: 49.0968,
    x2: 262.727,
    y2: 49.0968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_13970_23982",
    x1: 260.337,
    y1: 49.334,
    x2: 261.068,
    y2: 49.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_13970_23982",
    x1: 258.711,
    y1: 49.5752,
    x2: 259.407,
    y2: 49.5752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_13970_23982",
    x1: 257.097,
    y1: 49.8109,
    x2: 257.747,
    y2: 49.8109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_13970_23982",
    x1: 255.477,
    y1: 50.0491,
    x2: 256.093,
    y2: 50.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_13970_23982",
    x1: 253.857,
    y1: 50.2906,
    x2: 254.439,
    y2: 50.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_13970_23982",
    x1: 252.23,
    y1: 50.526,
    x2: 252.777,
    y2: 50.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_13970_23982",
    x1: 250.611,
    y1: 50.764,
    x2: 251.124,
    y2: 50.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_13970_23982",
    x1: 248.996,
    y1: 51.0055,
    x2: 249.464,
    y2: 51.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_13970_23982",
    x1: 247.369,
    y1: 51.2411,
    x2: 247.803,
    y2: 51.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_13970_23982",
    x1: 245.749,
    y1: 51.4791,
    x2: 246.148,
    y2: 51.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_13970_23982",
    x1: 244.128,
    y1: 51.7205,
    x2: 244.493,
    y2: 51.7205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_13970_23982",
    x1: 242.509,
    y1: 51.9528,
    x2: 242.84,
    y2: 51.9528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_13970_23982",
    x1: 240.888,
    y1: 52.1941,
    x2: 241.174,
    y2: 52.1941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_13970_23982",
    x1: 239.268,
    y1: 52.4287,
    x2: 239.519,
    y2: 52.4287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_13970_23982",
    x1: 237.654,
    y1: 52.6699,
    x2: 237.859,
    y2: 52.6699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_13970_23982",
    x1: 236.033,
    y1: 52.9078,
    x2: 236.204,
    y2: 52.9078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_13970_23982",
    x1: 234.409,
    y1: 53.1437,
    x2: 234.546,
    y2: 53.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_13970_23982",
    x1: 232.787,
    y1: 53.3817,
    x2: 232.89,
    y2: 53.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_13970_23982",
    x1: 231.166,
    y1: 53.624,
    x2: 231.236,
    y2: 53.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_13970_23982",
    x1: 229.547,
    y1: 53.8594,
    x2: 229.571,
    y2: 53.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_13970_23982",
    x1: 297.618,
    y1: 42.2156,
    x2: 299.17,
    y2: 42.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_13970_23982",
    x1: 295.981,
    y1: 42.4605,
    x2: 297.533,
    y2: 42.4605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_13970_23982",
    x1: 294.362,
    y1: 42.6964,
    x2: 295.88,
    y2: 42.6964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_13970_23982",
    x1: 292.735,
    y1: 42.9377,
    x2: 294.218,
    y2: 42.9377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_13970_23982",
    x1: 291.115,
    y1: 43.1756,
    x2: 292.564,
    y2: 43.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_13970_23982",
    x1: 289.5,
    y1: 43.4114,
    x2: 290.904,
    y2: 43.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_13970_23982",
    x1: 287.88,
    y1: 43.6517,
    x2: 289.237,
    y2: 43.6517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_13970_23982",
    x1: 286.262,
    y1: 43.8875,
    x2: 287.585,
    y2: 43.8875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_13970_23982",
    x1: 284.64,
    y1: 44.1256,
    x2: 285.929,
    y2: 44.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_13970_23982",
    x1: 283.02,
    y1: 44.3669,
    x2: 284.275,
    y2: 44.3669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_13970_23982",
    x1: 281.394,
    y1: 44.6027,
    x2: 282.615,
    y2: 44.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_13970_23982",
    x1: 279.774,
    y1: 44.8406,
    x2: 280.961,
    y2: 44.8406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_13970_23982",
    x1: 278.16,
    y1: 45.0818,
    x2: 279.301,
    y2: 45.0818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_13970_23982",
    x1: 276.538,
    y1: 45.3176,
    x2: 277.645,
    y2: 45.3176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_13970_23982",
    x1: 274.918,
    y1: 45.5546,
    x2: 275.98,
    y2: 45.5546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_13970_23982",
    x1: 273.3,
    y1: 45.7899,
    x2: 274.326,
    y2: 45.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_13970_23982",
    x1: 271.679,
    y1: 46.0315,
    x2: 272.671,
    y2: 46.0315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_13970_23982",
    x1: 270.053,
    y1: 46.2696,
    x2: 271.011,
    y2: 46.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_13970_23982",
    x1: 268.438,
    y1: 46.505,
    x2: 269.351,
    y2: 46.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_13970_23982",
    x1: 266.818,
    y1: 46.7466,
    x2: 267.697,
    y2: 46.7466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_13970_23982",
    x1: 265.197,
    y1: 46.9846,
    x2: 266.041,
    y2: 46.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_13970_23982",
    x1: 263.572,
    y1: 47.217,
    x2: 264.382,
    y2: 47.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_13970_23982",
    x1: 261.951,
    y1: 47.4617,
    x2: 262.727,
    y2: 47.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_13970_23982",
    x1: 260.337,
    y1: 47.6987,
    x2: 261.068,
    y2: 47.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_13970_23982",
    x1: 258.711,
    y1: 47.9341,
    x2: 259.407,
    y2: 47.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_13970_23982",
    x1: 257.097,
    y1: 48.1756,
    x2: 257.747,
    y2: 48.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_13970_23982",
    x1: 255.477,
    y1: 48.4137,
    x2: 256.093,
    y2: 48.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_13970_23982",
    x1: 253.857,
    y1: 48.6495,
    x2: 254.439,
    y2: 48.6495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_13970_23982",
    x1: 252.23,
    y1: 48.8907,
    x2: 252.777,
    y2: 48.8907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_13970_23982",
    x1: 250.611,
    y1: 49.1289,
    x2: 251.124,
    y2: 49.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_13970_23982",
    x1: 248.996,
    y1: 49.3646,
    x2: 249.464,
    y2: 49.3646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_13970_23982",
    x1: 247.369,
    y1: 49.6058,
    x2: 247.803,
    y2: 49.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_13970_23982",
    x1: 245.749,
    y1: 49.8438,
    x2: 246.148,
    y2: 49.8438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_13970_23982",
    x1: 244.128,
    y1: 50.0797,
    x2: 244.493,
    y2: 50.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_13970_23982",
    x1: 242.509,
    y1: 50.3177,
    x2: 242.84,
    y2: 50.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_13970_23982",
    x1: 240.888,
    y1: 50.5589,
    x2: 241.174,
    y2: 50.5589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_13970_23982",
    x1: 239.268,
    y1: 50.7936,
    x2: 239.519,
    y2: 50.7936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_13970_23982",
    x1: 237.654,
    y1: 51.035,
    x2: 237.859,
    y2: 51.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_13970_23982",
    x1: 236.033,
    y1: 51.2671,
    x2: 236.204,
    y2: 51.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_13970_23982",
    x1: 234.409,
    y1: 51.5086,
    x2: 234.546,
    y2: 51.5086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_13970_23982",
    x1: 232.787,
    y1: 51.7467,
    x2: 232.89,
    y2: 51.7467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_13970_23982",
    x1: 231.166,
    y1: 51.9831,
    x2: 231.236,
    y2: 51.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_13970_23982",
    x1: 229.547,
    y1: 52.2244,
    x2: 229.571,
    y2: 52.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_13970_23982",
    x1: 297.618,
    y1: 40.5804,
    x2: 299.17,
    y2: 40.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_13970_23982",
    x1: 295.981,
    y1: 40.8198,
    x2: 297.533,
    y2: 40.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_13970_23982",
    x1: 294.362,
    y1: 41.0613,
    x2: 295.88,
    y2: 41.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_13970_23982",
    x1: 292.735,
    y1: 41.3023,
    x2: 294.218,
    y2: 41.3023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_13970_23982",
    x1: 291.115,
    y1: 41.5345,
    x2: 292.564,
    y2: 41.5345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_13970_23982",
    x1: 289.5,
    y1: 41.7762,
    x2: 290.904,
    y2: 41.7762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_13970_23982",
    x1: 287.88,
    y1: 42.0108,
    x2: 289.237,
    y2: 42.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_13970_23982",
    x1: 286.262,
    y1: 42.2524,
    x2: 287.585,
    y2: 42.2524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_13970_23982",
    x1: 284.64,
    y1: 42.4905,
    x2: 285.929,
    y2: 42.4905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_13970_23982",
    x1: 283.02,
    y1: 42.7258,
    x2: 284.275,
    y2: 42.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_13970_23982",
    x1: 281.394,
    y1: 42.9675,
    x2: 282.615,
    y2: 42.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_13970_23982",
    x1: 279.774,
    y1: 43.2055,
    x2: 280.961,
    y2: 43.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_13970_23982",
    x1: 278.16,
    y1: 43.4409,
    x2: 279.301,
    y2: 43.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_13970_23982",
    x1: 276.538,
    y1: 43.6825,
    x2: 277.645,
    y2: 43.6825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_13970_23982",
    x1: 274.918,
    y1: 43.9192,
    x2: 275.98,
    y2: 43.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_13970_23982",
    x1: 273.3,
    y1: 44.1549,
    x2: 274.326,
    y2: 44.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_13970_23982",
    x1: 271.679,
    y1: 44.3963,
    x2: 272.671,
    y2: 44.3963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_13970_23982",
    x1: 270.053,
    y1: 44.6343,
    x2: 271.011,
    y2: 44.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_13970_23982",
    x1: 268.438,
    y1: 44.8699,
    x2: 269.351,
    y2: 44.8699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_13970_23982",
    x1: 266.818,
    y1: 45.1115,
    x2: 267.697,
    y2: 45.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_13970_23982",
    x1: 265.197,
    y1: 45.3494,
    x2: 266.041,
    y2: 45.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_13970_23982",
    x1: 263.572,
    y1: 45.5818,
    x2: 264.382,
    y2: 45.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_13970_23982",
    x1: 261.951,
    y1: 45.8264,
    x2: 262.727,
    y2: 45.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_13970_23982",
    x1: 260.337,
    y1: 46.0578,
    x2: 261.068,
    y2: 46.0578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_13970_23982",
    x1: 258.711,
    y1: 46.299,
    x2: 259.407,
    y2: 46.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_13970_23982",
    x1: 257.097,
    y1: 46.5407,
    x2: 257.747,
    y2: 46.5407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_13970_23982",
    x1: 255.477,
    y1: 46.773,
    x2: 256.093,
    y2: 46.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_13970_23982",
    x1: 253.857,
    y1: 47.0146,
    x2: 254.439,
    y2: 47.0146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_13970_23982",
    x1: 252.23,
    y1: 47.2556,
    x2: 252.777,
    y2: 47.2556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_13970_23982",
    x1: 250.611,
    y1: 47.488,
    x2: 251.124,
    y2: 47.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_13970_23982",
    x1: 248.996,
    y1: 47.7295,
    x2: 249.464,
    y2: 47.7295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_13970_23982",
    x1: 247.369,
    y1: 47.9707,
    x2: 247.803,
    y2: 47.9707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_13970_23982",
    x1: 245.749,
    y1: 48.2029,
    x2: 246.148,
    y2: 48.2029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_13970_23982",
    x1: 244.128,
    y1: 48.4446,
    x2: 244.493,
    y2: 48.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_13970_23982",
    x1: 242.509,
    y1: 48.6827,
    x2: 242.84,
    y2: 48.6827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_13970_23982",
    x1: 240.888,
    y1: 48.918,
    x2: 241.174,
    y2: 48.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_13970_23982",
    x1: 239.268,
    y1: 49.1585,
    x2: 239.519,
    y2: 49.1585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_13970_23982",
    x1: 237.654,
    y1: 49.3939,
    x2: 237.859,
    y2: 49.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_13970_23982",
    x1: 236.033,
    y1: 49.6319,
    x2: 236.204,
    y2: 49.6319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_13970_23982",
    x1: 234.409,
    y1: 49.8735,
    x2: 234.546,
    y2: 49.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_13970_23982",
    x1: 232.787,
    y1: 50.1058,
    x2: 232.89,
    y2: 50.1058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_13970_23982",
    x1: 231.166,
    y1: 50.3478,
    x2: 231.236,
    y2: 50.3478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_13970_23982",
    x1: 229.547,
    y1: 50.589,
    x2: 229.571,
    y2: 50.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_13970_23982",
    x1: 297.618,
    y1: 38.9453,
    x2: 299.17,
    y2: 38.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_13970_23982",
    x1: 295.981,
    y1: 39.1845,
    x2: 297.533,
    y2: 39.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_13970_23982",
    x1: 294.362,
    y1: 39.426,
    x2: 295.88,
    y2: 39.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_13970_23982",
    x1: 292.735,
    y1: 39.6615,
    x2: 294.218,
    y2: 39.6615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_13970_23982",
    x1: 291.115,
    y1: 39.8996,
    x2: 292.564,
    y2: 39.8996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_13970_23982",
    x1: 289.5,
    y1: 40.1411,
    x2: 290.904,
    y2: 40.1411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_13970_23982",
    x1: 287.88,
    y1: 40.3757,
    x2: 289.237,
    y2: 40.3757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_13970_23982",
    x1: 286.262,
    y1: 40.6113,
    x2: 287.585,
    y2: 40.6113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_13970_23982",
    x1: 284.64,
    y1: 40.8496,
    x2: 285.929,
    y2: 40.8496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_13970_23982",
    x1: 283.02,
    y1: 41.0907,
    x2: 284.275,
    y2: 41.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_13970_23982",
    x1: 281.394,
    y1: 41.3322,
    x2: 282.615,
    y2: 41.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_13970_23982",
    x1: 279.774,
    y1: 41.5646,
    x2: 280.961,
    y2: 41.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_13970_23982",
    x1: 278.16,
    y1: 41.8058,
    x2: 279.301,
    y2: 41.8058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_13970_23982",
    x1: 276.538,
    y1: 42.0473,
    x2: 277.645,
    y2: 42.0473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_13970_23982",
    x1: 274.918,
    y1: 42.2785,
    x2: 275.98,
    y2: 42.2785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_13970_23982",
    x1: 273.3,
    y1: 42.5196,
    x2: 274.326,
    y2: 42.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_13970_23982",
    x1: 271.679,
    y1: 42.7612,
    x2: 272.671,
    y2: 42.7612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_13970_23982",
    x1: 270.053,
    y1: 42.9935,
    x2: 271.011,
    y2: 42.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_13970_23982",
    x1: 268.438,
    y1: 43.2348,
    x2: 269.351,
    y2: 43.2348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_13970_23982",
    x1: 266.818,
    y1: 43.4762,
    x2: 267.697,
    y2: 43.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_13970_23982",
    x1: 265.197,
    y1: 43.7085,
    x2: 266.041,
    y2: 43.7085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_13970_23982",
    x1: 263.572,
    y1: 43.9465,
    x2: 264.382,
    y2: 43.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_13970_23982",
    x1: 261.951,
    y1: 44.1913,
    x2: 262.727,
    y2: 44.1913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_13970_23982",
    x1: 260.337,
    y1: 44.4228,
    x2: 261.068,
    y2: 44.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_13970_23982",
    x1: 258.711,
    y1: 44.6638,
    x2: 259.407,
    y2: 44.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_13970_23982",
    x1: 257.097,
    y1: 44.8998,
    x2: 257.747,
    y2: 44.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_13970_23982",
    x1: 255.477,
    y1: 45.1377,
    x2: 256.093,
    y2: 45.1377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_13970_23982",
    x1: 253.857,
    y1: 45.3792,
    x2: 254.439,
    y2: 45.3792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_13970_23982",
    x1: 252.23,
    y1: 45.6147,
    x2: 252.777,
    y2: 45.6147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_13970_23982",
    x1: 250.611,
    y1: 45.8527,
    x2: 251.124,
    y2: 45.8527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_13970_23982",
    x1: 248.996,
    y1: 46.0942,
    x2: 249.464,
    y2: 46.0942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_13970_23982",
    x1: 247.369,
    y1: 46.3298,
    x2: 247.803,
    y2: 46.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_13970_23982",
    x1: 245.749,
    y1: 46.5678,
    x2: 246.148,
    y2: 46.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_13970_23982",
    x1: 244.128,
    y1: 46.8094,
    x2: 244.493,
    y2: 46.8094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_13970_23982",
    x1: 242.509,
    y1: 47.0418,
    x2: 242.84,
    y2: 47.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_13970_23982",
    x1: 240.888,
    y1: 47.2829,
    x2: 241.174,
    y2: 47.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_13970_23982",
    x1: 239.268,
    y1: 47.5174,
    x2: 239.519,
    y2: 47.5174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_13970_23982",
    x1: 237.654,
    y1: 47.7587,
    x2: 237.859,
    y2: 47.7587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_13970_23982",
    x1: 236.033,
    y1: 47.9968,
    x2: 236.204,
    y2: 47.9968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_13970_23982",
    x1: 234.409,
    y1: 48.2325,
    x2: 234.546,
    y2: 48.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_13970_23982",
    x1: 232.787,
    y1: 48.4706,
    x2: 232.89,
    y2: 48.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_13970_23982",
    x1: 231.166,
    y1: 48.7126,
    x2: 231.236,
    y2: 48.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_13970_23982",
    x1: 229.547,
    y1: 48.9481,
    x2: 229.571,
    y2: 48.9481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05AD8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoon);
export default __webpack_public_path__ + "static/media/Coming soon.19bde627d3668e8534271da763835a28.svg";
export { ForwardRef as ReactComponent };